<template>
  <div class="devcomp">

    <el-row>
      <el-col :span="24">
        <div class="search">
          <el-form :inline="true" class="demo-form-inline">


            <el-form-item label="  ">
              <el-autocomplete size="small" v-model="searchdls" :fetch-suggestions="querySearchAsync"
                placeholder="输入账号名称" clearable @select="handleSelect" @keyup.enter.native="onRefresh()"
                @clear="onRefresh()">
                <template slot="prepend">按设备所属筛选：</template>
                <el-button slot="append" @click="onRefresh" icon="el-icon-search"></el-button>
              </el-autocomplete>
            </el-form-item>

            <!-- <el-form-item style="margin-left: 20px;" label="按状态筛选：">
              <el-select @change="onRefresh" style="width: 150px" v-model="ssvalue" placeholder="请选择">
                <el-option v-for="item in sselect" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item> -->
            <!-- <el-form-item label="  ">
              <el-input style="width: 275px" placeholder="次数小于" v-model="leinput" maxlength="2" clearable
                @keyup.enter.native="onRefresh()" @clear="onRefresh()">
                <template slot="prepend">剩余次数 ≤</template>
<el-button slot="append" @click="onRefresh" icon="el-icon-search"></el-button>

</el-input>
</el-form-item> -->


            <el-form-item label="  ">
              <el-input size="small" style="width: 325px" placeholder="设备编号筛选" v-model="searchsn" maxlength="15"
                clearable @keyup.enter.native="onRefresh()" @clear="onRefresh()">
                <!--                <template slot="prepend">设备编号SN：</template>-->
                <el-select size="small" v-model="SNorCID" slot="prepend" style="width: 135px" @change="onRefresh">
                  <el-option label="设备编号筛选" key="cid" value="cid"></el-option>
                  <el-option label="4G编号筛选" key="sn" value="sn"></el-option>
                </el-select>
                <el-button slot="append" @click="onRefresh" icon="el-icon-search"></el-button>

              </el-input>
            </el-form-item>


            <el-form-item label="  ">
              <el-input size="small" style="width: 400px" placeholder="输入设备命名" v-model="deviceinput" clearable
                @clear="onRefresh()" @keyup.enter.native="onRefresh()">
                <template slot="prepend">设备命名筛选:</template>
                <el-button slot="append" @click="onRefresh" icon="el-icon-search"></el-button>
              </el-input>
            </el-form-item>

            <el-form-item label="  ">
              <el-input size="small" style="width: 320px" placeholder="手机号筛选" v-model="searchphone" maxlength="11"
                clearable @keyup.enter.native="onRefresh()" @clear="onRefresh()">
                <template slot="prepend">用户手机号：</template>
                <el-button slot="append" @click="onRefresh" icon="el-icon-search"></el-button>

              </el-input>
            </el-form-item>

            <!-- 
            <el-form-item label="  ">
              <el-input size="small" style="width: 400px" placeholder="输入客户名称" v-model="searchinput" clearable
                @clear="onRefresh()" @keyup.enter.native="onRefresh()">
                <template slot="prepend">设备所属客户筛选:</template>
                <el-button slot="append" @click="onRefresh" icon="el-icon-search"></el-button>
              </el-input>
            </el-form-item> -->



            <!-- <el-button icon="el-icon-postcard" style="margin-left: 20px;width: 160px" type="info" plain
              @click="OfflineDialog = true; OfflineCommited = false">离线密码充次
            </el-button> -->



          </el-form>

        </div>
        <div class="search">


        </div>

        <el-table :data="tbdata" border stripe height="760" style="width: 100%; margin: 3px"
          class="custom-striped-table">

          <el-table-column v-if="SNorCID == 'sn'" prop="cid" align="center" label="IMEI" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.sn }}</span>


              <el-button type="text" @click="OpenChangeModelDialog(scope.$index, 0)" plain size="mini"
                style="color:darkgreen;" v-if="scope.row.mod == 'F0C1T'">(艾灸床触屏)</el-button>
              <el-button type="text" @click="OpenChangeModelDialog(scope.$index, 0)" plain size="mini"
                style="color:blue;" v-else-if="scope.row.mod == 'F0C5T'">(透灸仪)</el-button>
              <el-button type="text" @click="OpenChangeModelDialog(scope.$index, 0)" plain size="mini"
                style="color:darkred;" v-else-if="scope.row.mod == 'F0C2T'">(熏蒸床)</el-button>
              <el-button type="text" @click="OpenChangeModelDialog(scope.$index, 0)" plain size="mini"
                style="color:red;" v-else-if="scope.row.mod == 'F0C1D'">(艾灸床F0)</el-button>
              <el-button type="text" @click="OpenChangeModelDialog(scope.$index, 0)" plain size="mini"
                style="color:DarkMagenta;" v-else-if="scope.row.mod == 'F3C1D'">(艾灸床F3)</el-button>
              <!-- <el-button type="text" @click="OpenChangeModelDialog(scope.$index, 0)" plain size="mini"
                style="color:DeepPink ;" v-else-if="scope.row.mod == 'F3C1AA'">(艾灸床AA)</el-button>-->
              <el-button type="text" @click="OpenChangeModelDialog(scope.$index, 0)" plain size="mini"
                style="color:#606266;" v-else>({{ scope.row.mod }})</el-button>
            </template>
          </el-table-column>
          <el-table-column v-if="SNorCID == 'cid'" prop="cid" align="center" label="设备编号" width="135">
            <template slot-scope="scope">
              {{ scope.row.cid }}
              <span style="font-size: 12px;color:darkgreen;" v-if="scope.row.mod == 'F0C1T'">(艾灸床)</span>
              <span style="font-size: 12px;color:blue;" v-if="scope.row.mod == 'F0C9T'">(净烟仪)</span>
              <span style="font-size: 12px;color:darkred;" v-if="scope.row.mod == 'F0C2T'">(熏蒸床)</span>
              <span style="font-size: 12px;color:red;" v-if="scope.row.mod == 'F0C1D'">(艾灸床A)</span>
              <span style="font-size: 12px;color:DarkMagenta;" v-if="scope.row.mod == 'F3C1D'">(艾灸床H)</span>
            </template>
          </el-table-column>

          <el-table-column prop="cb" width="60" label="版本" align="center" >
          </el-table-column>

          <el-table-column prop="st" width="90" label="状态" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.fly == 'fly'">
                <el-tag type="primary" disable-transitions>
                  <i class="el-icon-s-promotion"></i>飞行</el-tag>
              </span>
              <span v-if="scope.row.fly != 'fly'">
                <el-tag v-if="!scope.row.lock" :type="scope.row.st === '在线'
                  ? 'success'
                  : scope.row.st === '运行'
                    ? 'danger'
                    : 'info'
                  " disable-transitions>{{ scope.row.st }}</el-tag>

                <el-tag v-if="scope.row.lock" type="warning" disable-transitions>
                  <i class="el-icon-lock"></i>锁机</el-tag>
              </span>
            </template>
          </el-table-column>

          <!-- <el-table-column prop="dls" label="代理商" align="center">
          </el-table-column> -->


          <el-table-column prop="dls" label="设备归属" align="center">
            <template slot-scope="scope">
              <!-- <span> -->
              <el-button type="text" @click="OpenAllocateDialog(scope.$index, 0)" plain>{{ scope.row.dls }}</el-button>
              <!-- </span> -->
            </template>
          </el-table-column>

          <!-- <el-table-column prop="dev" label="设备名" align="center">
          </el-table-column> -->

          <el-table-column  prop="dev" align="center" label="设备名" >
            <template slot-scope="scope">
              {{ scope.row.dev }}
              <span style="display: block; font-size: 12px;color:darkblue; ">{{ scope.row.ip }}</span>
            </template>
          </el-table-column>


          <el-table-column prop="ph" width="130" label="联系方式" align="center">
          </el-table-column>

          <el-table-column v-if="ssvalue != '单机'" prop="td" width="80" label="今天使用" align="center"
            :formatter="countFormatter">
          </el-table-column>

          <el-table-column v-if="ssvalue != '单机'" prop="tt" width="80" label="总计使用" align="center"
            :formatter="countFormatter">
          </el-table-column>



          <el-table-column prop="cnt" width="80" label="剩余次数" align="center" :formatter="countFormatter">
          </el-table-column>


          <!-- <el-table-column label="剩余天数" width="80" align="center">
            <template #default="scope">
              <span :style="{ color: getDayColor(scope.row.remain_day) }">
                {{ formatRemainDay(scope.row.remain_day) }}
              </span>
            </template>
          </el-table-column> -->


          <el-table-column prop="st" width="220" label="设备远程控制" align="center">
            <template slot-scope="scope">
              <el-popover placement="top" width="220" v-model="scope._vis_">
                <div style="text-align: center; margin: 0">
                  <p>设备远程启停控制</p>

                  <el-button size="mini" icon="el-icon-video-play" type="success" plain
                    @click="DeviceTrunDirect(scope.$index, 'start')">启动设备</el-button>
                  <el-button size="mini" icon="el-icon-video-pause" type="danger" plain
                    @click="DeviceTrunDirect(scope.$index, 'stop')">停止设备</el-button>
                </div>
                <el-button style="margin: 0 5px;" size="mini" plain slot="reference">启停</el-button>
              </el-popover>

              <span>
                <!-- <el-divider direction="vertical"></el-divider> -->
                <!-- || scope.row.mod == 'F3C1D' -->
                <el-button :disabled="scope.row.mod == 'F0C1D' " size="mini"
                  style="margin: 0 5px;" @click="OpenConfigDialog(scope.$index)" plain>设置</el-button>
              </span>

              <span v-if="pg_list.charge_device">
                <!-- <el-divider direction="vertical"></el-divider> -->
                <el-button :disabled="scope.row.mod == 'X1'" size="mini" style="margin: 0 5px;"
                  @click="OpenRechargeDialog(scope.$index)" plain>充值</el-button>
              </span>

            </template>
          </el-table-column>





          <el-table-column width="250">
            <template slot="header">
              <el-button type="primary" icon="el-icon-refresh" style="margin-left: 10px;width: 160px"
                @click="onRefresh"> 刷 新
              </el-button>
              <!--              <el-button icon="el-icon-plus" type="primary" plain style="margin-left: 18px;width: 120px"-->
              <!--                         @click="AddOfflineDeviceDialog">添加单机-->
              <!--              </el-button>-->
              <!-- 
              <el-button type="primary" icon="el-icon-download" style="margin-left: 18px;width: 120px" plain
                @click="ExportDeviceExcel">导出本页
              </el-button> -->


            </template>
            <template slot-scope="scope">
              <span>
                <el-button style="margin-left: 1px" size="mini" @click="OpenModifyDialog(scope.$index)">修改</el-button>

              </span>


              <el-divider v-if="pg_list.location" direction="vertical"></el-divider>
              <el-button v-if="pg_list.location" size="mini" @click="OpenMapDialog(scope.$index)" plain>定位</el-button>



              <el-popover v-if="scope.row.mod == 'X1'" placement="top" width="180" v-model="scope._vis2_">
                <div style="text-align: center; margin: 0">
                  <p>确认删除设备"{{ tbdata[scope.$index].dev }}"吗？删除后无法恢复</p>

                  <el-button size="mini" icon="el-icon-delete" type="danger" plain
                    @click="DeleteDeviceCommit(scope.$index)">确认删除</el-button>
                </div>
                <el-button size="mini" icon="el-icon-delete" type="danger" plain slot="reference">删除</el-button>
              </el-popover>

              <el-divider direction="vertical"></el-divider>

              <el-popover placement="top" width="220" v-model="scope._vis_export_">
                <div style="text-align: center; margin: 0">
                  <p>导出Excel报表</p>

                  <el-button v-if="scope.row.mod != 'X1'" icon="el-icon-tickets"
                    @click="ExportExcelDialog(scope.$index)" size="mini">使用记录</el-button>
                  <el-button icon="el-icon-pie-chart" style="margin-left: 10px"
                    @click="ExportChargeDialog(scope.$index)" size="mini"
                    v-if="pg_list.charge_order_export">充次记录</el-button>
                </div>
                <el-button size="mini" plain slot="reference">导出</el-button>
              </el-popover>


            </template>
          </el-table-column>
        </el-table>
        <div style="display: flex;align-items: center;justify-content:flex-start">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currPage"
            :page-sizes="[12, 24, 36, 48]" :page-size="currSize" layout="total, sizes, prev, pager, next, jumper"
            :total="currTotal">
          </el-pagination>


          <span style="margin-left: 40px">
            每10秒刷新:
            <el-switch style="margin-right: 7px" v-model="autoRefreshFlag" @change="handleSwitchChange">
            </el-switch>
            <span v-if="autoRefreshFlag">开</span>
            <span v-if="!autoRefreshFlag">关</span>
          </span>



          <el-checkbox style="margin-left: 40px;" v-model="ordercheck" @change="onRefresh">按设备编号排序</el-checkbox>
        </div>
      </el-col>



    </el-row>

    <!--  锁机  -->
    <!--    <el-dialog title="锁机" :visible.sync="LockDialog" width="500px">-->
    <!--      <el-form :model="Lock">-->
    <!--        <el-form-item label="当前设备:" label-width="100px">-->
    <!--          {{LockName}}-->
    <!--        </el-form-item>-->

    <!--        <el-form-item label="设备编号:" label-width="100px">-->
    <!--          {{LockCid}}-->
    <!--        </el-form-item>-->

    <!--        <el-form-item label="当前状态:" label-width="100px">-->
    <!--          <el-tag-->
    <!--              v-if="!LockID"-->
    <!--              :type="-->
    <!--                    LockStatus === '在线'-->
    <!--                      ? 'success'-->
    <!--                      : LockStatus === '运行'-->
    <!--                      ? 'danger'-->
    <!--                      : 'info'-->
    <!--                  "-->
    <!--              disable-transitions>{{LockStatus}}</el-tag>-->

    <!--          <el-tag-->
    <!--              v-if="LockID"-->
    <!--              type="warning"-->
    <!--              disable-transitions>-->
    <!--            <i class="el-icon-lock"></i>锁机</el-tag>-->
    <!--        </el-form-item>-->

    <!--        <el-form-item label="锁机原因:" label-width="100px">-->
    <!--          <el-input v-model="Lock.reason" autocomplete="off"   maxlength="20"  show-word-limit-->
    <!--          ></el-input>-->
    <!--        </el-form-item>-->
    <!--        <el-form-item label="备注信息:" label-width="100px"   >-->
    <!--          <el-input-->
    <!--              type="textarea"-->
    <!--              :rows="3"-->
    <!--              placeholder="请输入备注信息"-->
    <!--              maxlength="200"  show-word-limit-->
    <!--              v-model="Lock.notes">-->
    <!--          </el-input>-->
    <!--        </el-form-item>-->
    <!--        <el-form-item label="操作人员:" label-width="100px">-->
    <!--          <el-input v-model="Lock.operator" autocomplete="off" maxlength="20"  show-word-limit></el-input>-->
    <!--        </el-form-item>-->
    <!--        <el-form-item label="操作密码:" label-width="100px">-->
    <!--          <el-input v-model="Lock.op_password" autocomplete="off" show-password></el-input>-->
    <!--        </el-form-item>-->
    <!--      </el-form>-->

    <!--      <div slot="footer" class="dialog-footer">-->
    <!--        <el-button @click="LockDialog = false;onRefresh()" style="margin-right: 20px">取 消</el-button>-->
    <!--        <el-button type="success" @click="LockCommit(0)">解 锁</el-button>-->
    <!--        <el-button type="danger" @click="LockCommit(1)">锁 定</el-button>-->
    <!--      </div>-->
    <!--    </el-dialog>-->

    <!-- 充值次数 Start -->
    <el-dialog title="设备充值：次数/可用天数设置" :visible.sync="RechargeTimesDialog" width="660px"
      style="border-radius: 12px; overflow: hidden; box-shadow: 0 4px 20px rgba(0,0,0,0.15);">
      <el-form v-loading="chargeLoading" style="padding: 20px;">

        <!-- 设备信息卡片 -->
        <el-card shadow="hover"
          style="margin-bottom: 20px; border-radius: 8px; padding: 1px; background-color: #fafafa;">
          <div style="text-align: center; font-weight: bold; color: #333;">
            <div style="font-size: 22px; margin-bottom: 8px; color: #409EFF;">
              当前设备：{{ ChargeCurr.Name }}
            </div>
            <div style="display: flex; justify-content: center; gap: 20px; margin-bottom: 8px;">
              <span>设备编号：{{ ChargeCurr.CID }}</span>
              <span>串号：{{ ChargeCurr.SN }}</span>
            </div>
            <div style="display: flex; justify-content: center; gap: 20px; color: #666;">
              <span>当前状态：{{ RechargeInfoSystus }}</span>
              <span>|</span>
              <span>当前信号：{{ ChargeCurr.Rssi }}</span>
            </div>
          </div>
          <div style="display: flex; justify-content: center; align-items: center; gap: 10px; margin-top: 10px;">
            <span style="font-weight: bold; color: #333;">数据上报时间：{{ RechargeInfoUpdateTime }}</span>
          </div>
          <div style="display: flex; justify-content: center; align-items: center; gap: 10px; margin-top: 10px;">
            <span style="font-weight: bold; color: darkgreen;">当前次数：{{ OnlineForm.old }} 次</span>
            <span>|</span>
            <span style="font-weight: bold; color: darkgreen;">剩余天数：{{ ChargeCurr.remday }} 天</span>
            <span>|</span>
            <span style="font-weight: bold; color: darkgreen;">有效日期：{{ ChargeCurr.exprday }} </span>

          </div>
          <!-- 飞行模式提示 -->
          <!-- <div v-if="FlyModeFlag" style="margin-top: 10px;">
        <el-alert 
          title="该设备通讯可能存在干扰，已开启飞行模式。充次前请先关闭飞行模式，然后提醒客户断电重新上电，刷新显示在线后再充次，充次完成后重新打开飞行模式。" 
          type="warning" 
          :closable="false"
          style="margin-top: 5px;">
        </el-alert>
      </div> -->
        </el-card>

        <div style="display: flex; justify-content: space-between; gap: 20px;">
          <!-- 左边卡片 -->

          <div style="flex: 1; padding: 20px; border: 1px solid #ebeef5; border-radius: 8px; background-color: #fff;">
            <span class="demonstration" style="font-weight: bold; display: block; margin-bottom: 10px;">到期时间设置</span>
            <el-date-picker v-model="ChargeDayValue" align="right" type="date" placeholder="选择日期"
              value-format="yyyy-MM-dd" :picker-options="pickerOptionsDay" style="margin-bottom: 10px;">
            </el-date-picker>
            <el-button type="primary" icon="el-icon-check" @click="RechargeDayCommit"
              style="padding: 8px 15px;">设置</el-button>
            <el-button type="warning" icon="el-icon-warning" @click="RechargeNullDayCommit"
              style="padding: 8px 15px;">改为不限时</el-button>
            <p style="font-size: 12px; color: #999; margin-top: 5px;">（充次时请先保证设备没有到期）</p>

          </div>
          <!-- 右边卡片 -->

          <div style="flex: 1; padding: 20px; border: 1px solid #ebeef5; border-radius: 8px; background-color: #fff;">
            <span class="demonstration" style="font-weight: bold; display: block; margin-bottom: 10px;">可用次数设定</span>

            <el-form-item label="次数设定" label-width="70px" style="margin-bottom: 10px;">
              <el-input style="width: 60px; text-align: center;" v-model="OnlineForm.edit"></el-input> 次
            </el-form-item>
            <el-button icon="el-icon-position" type="success" @click="RechargeCommit"
              style="padding: 8px 10px; margin-right: 10px;">
              发送充次
            </el-button>
            <!-- <el-button v-if="ChargeCommited" icon="el-icon-position" type="warning" @click="RechargeCommit"
              style="padding: 8px 10px; margin-right: 10px;">
              充次
            </el-button> -->
            <!-- <el-button :disabled="!ChargeCommited" icon="el-icon-finished" type="success" @click="RechargeConfirmCommit"
              style="padding: 8px 20px;">
              确认
            </el-button> -->
            <p style="font-size: 12px; color: #999; margin-top: 1px;">（次数设定直接覆盖次数，不累加）</p>
          </div>
        </div>

        <!-- 充值次数表单 -->
        <!-- <el-form :inline="true" :model="OnlineForm" class="demo-form-inline"
          style="text-align: center; margin-bottom: 20px;">
          <el-form-item label="当前次数" label-width="70px">
            <el-input style="width: 60px; text-align: center;" v-model="OnlineForm.old" :disabled="true"></el-input>
          </el-form-item>

          <el-form-item label="充后次数" label-width="70px">
            <el-input style="width: 60px; text-align: center;" v-model="OnlineForm.new" :disabled="true"></el-input>
          </el-form-item>
        </el-form> -->

        <!-- 提示信息 -->
        <!-- <el-alert v-if="!ChargeCommited" :title="chargedTxt" :type="chargedType" :closable="false"
          style="margin-bottom: 15px;">
        </el-alert>
        <el-alert v-if="ChargeCommited" title="已发送充次，请和用户确认是否充上，充上了点确认，没充上点再次充次" type="warning" :closable="false"
          style="margin-bottom: 15px;">
        </el-alert> -->

        <!-- 操作按钮 -->
        <div style="text-align: center; margin-top: 20px;">
          <el-button type="primary" round icon="el-icon-refresh" @click="RefleshChargeInfo">刷新</el-button>
          <el-button type="info" round icon="el-icon-close" @click="CloseRechargeDialog">返回</el-button>

        </div>

      </el-form>
    </el-dialog>
    <!-- 充值次数 END -->



    <!-- 滤芯核销 Start -->
    <!--    <el-dialog title="滤芯核销" :visible.sync="FilterVerifyDialog" width="1000px">-->

    <!--      <el-form :inline="true"  class="demo-form-inline">-->
    <!--        <el-form-item label="设备编号："  label-width="90px">-->
    <!--          <el-input style="width: 150px"  v-model="FilterVerifyCID" :disabled="true"></el-input>-->
    <!--        </el-form-item>-->

    <!--        <el-form-item label="核销客户名称：" label-width="140px">-->
    <!--          <el-input style="width: 150px" v-model="FilterVerifyName" :disabled="true"></el-input>-->
    <!--        </el-form-item>-->

    <!--        <el-form-item label="搜索待核销条码：" label-width="150px">-->
    <!--          <el-input style="width: 220px" clearable placeholder="输入条码" v-model="FilterVerifySearch" @keyup.enter.native="GetFilter()">-->
    <!--            &lt;!&ndash;                <template slot="prepend">查找用户:</template>&ndash;&gt;-->
    <!--            <el-button slot="append" @click="GetFilter" icon="el-icon-search">查询</el-button>-->
    <!--          </el-input>        </el-form-item>-->
    <!--      </el-form>-->
    <!--&lt;!&ndash;      table&ndash;&gt;-->
    <!--      <el-table-->
    <!--          :data="FilterVerifyData"-->
    <!--          border-->
    <!--          stripe-->
    <!--          height="330"-->
    <!--          style="width: 100%; margin: 3px"-->
    <!--      >-->

    <!--        <el-table-column prop="ci" width="160" label="滤芯条码" align="center">-->
    <!--        </el-table-column>-->

    <!--        <el-table-column prop="cd" width="140" label="滤芯批次" align="center">-->
    <!--        </el-table-column>-->

    <!--        <el-table-column prop="s" width="90" label="滤芯状态" align="center">-->
    <!--          <template slot-scope="scope">-->
    <!--            <el-tag-->
    <!--                :type="-->
    <!--                    scope.row.s === '未使用'-->
    <!--                      ? 'success'-->
    <!--                      : scope.row.s === '已使用'-->
    <!--                      ? 'info'-->
    <!--                      : 'danger'-->
    <!--                  "-->
    <!--                disable-transitions>{{scope.row.s}}</el-tag>-->
    <!--          </template>-->
    <!--        </el-table-column>-->


    <!--        <el-table-column prop="ct" width="160" label="创建时间" align="center">-->
    <!--        </el-table-column>-->

    <!--        <el-table-column prop="c" label="备注信息" align="center">-->
    <!--        </el-table-column>-->


    <!--        <el-table-column width="130">-->
    <!--          <template slot-scope="scope" label="操作" >-->

    <!--            <el-popconfirm-->
    <!--                :title="'滤芯码核销后不可撤销，确认将“'+scope.row.ci+'”核销给“'+FilterVerifyName+'”吗？'"-->
    <!--                @confirm="FilterVerifyCommit(scope.$index)"-->
    <!--            >-->
    <!--              <el-button :disabled="scope.row.s == '已使用'"  size="mini" icon="el-icon-finished"  type="primary"  plain slot="reference">核销滤芯</el-button>-->
    <!--            </el-popconfirm>-->


    <!--          </template>-->
    <!--        </el-table-column>-->
    <!--      </el-table>-->
    <!--    </el-dialog>-->
    <!-- 滤芯核销 END -->


    <!-- 历史记录 Start -->
    <!--    <el-dialog  :title="'历史数据查询 : '+HistoryDataName+'  (设备编号 : '+HistoryDataCID+')'" :visible.sync="HistoryDataDialog" width="1000px">-->

    <!--      <el-form :inline="true" class="demo-form-inline" v-loading="HistoryLoading">-->
    <!--        <el-form-item label=" 查询时间">-->
    <!--          <el-date-picker v-model="HistoryTime" type="daterange" align="right" unlink-panels range-separator="至"-->
    <!--                          start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions">-->
    <!--          </el-date-picker>-->
    <!--        </el-form-item>-->

    <!--        <el-form-item label="类别：">-->
    <!--          <el-select filterable @change="onRefreshHistory"  v-model="HSvalue" placeholder="请选择" style="width: 150px" >-->
    <!--            <el-option v-for="item in Hselect" :key="item.value" :label="item.label" :value="item.value">-->
    <!--            </el-option>-->
    <!--          </el-select>-->
    <!--        </el-form-item>-->


    <!--        <el-form-item label="  ">-->
    <!--          <el-button type="success" @click="onRefreshHistory" icon="el-icon-search">查 询</el-button>-->
    <!--        </el-form-item>-->

    <!--        <el-form-item label="  ">-->
    <!--          <el-button type="primary" @click="ExportHistoryExcel" icon="el-icon-download">导出Excel</el-button>-->
    <!--        </el-form-item>-->


    <!--      </el-form>-->
    <!--      &lt;!&ndash;      table&ndash;&gt;-->
    <!--      <el-table-->
    <!--          :data="HistoryDataData"-->
    <!--          border-->
    <!--          stripe-->
    <!--          height="550"-->
    <!--          style="width: 100%; margin: 3px"-->
    <!--      >-->

    <!--        <el-table-column prop="time"  label="记录时间" align="center">-->
    <!--        </el-table-column>-->

    <!--        <el-table-column prop="parse" :label="computedLabel" align="center">-->
    <!--        </el-table-column>-->

    <!--      </el-table>-->
    <!--    </el-dialog>-->
    <!-- 历史记录 END -->



    <!-- 修改床名字 Start -->
    <el-dialog :title="'修改设备信息 （设备编号：' + modifyCID + '）'" :visible.sync="modifyDeviceNameDialog" width="550px"
      style="border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.15);">
      <el-form style="padding: 20px;">
        <el-form-item label="客户名" label-width="80px" style="margin-bottom: 15px;">
          <el-input clearable v-model="modifyEditor" autocomplete="off" maxlength="16" show-word-limit
            style="width: 100%; padding-right: 10px;">
          </el-input>
        </el-form-item>

        <el-form-item label="手机号" label-width="80px" style="margin-bottom: 15px;">
          <el-input clearable v-model="modifyUserPhone" autocomplete="off" maxlength="15" show-word-limit
            style="width: 100%; padding-right: 10px;">
          </el-input>
        </el-form-item>

        <el-form-item label="设备区域" label-width="80px" style="margin-bottom: 15px;">
          <el-cascader style="width: 100%;" size="large" :options="regionData" v-model="modifySelectedArea">
          </el-cascader>
        </el-form-item>

        <el-form-item label="详细地址" label-width="80px" style="margin-bottom: 15px;">
          <el-input clearable v-model="modifyAddress" autocomplete="off" maxlength="120" show-word-limit
            style="width: 100%; padding-right: 10px;">
          </el-input>
        </el-form-item>

        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
          <div style="font-weight: bold; color: #606266;">设备备注：</div>
        </div>
        <el-input type="textarea" placeholder="请输入内容" v-model="modifyComments" :autosize="{ minRows: 4, maxRows: 6 }"
          maxlength="1000" show-word-limit style="width: 100%; padding: 10px; border-radius: 4px;">
        </el-input>
      </el-form>

      <div slot="footer" class="dialog-footer" style="display: flex; justify-content: flex-end; gap: 10px;">
        <el-button size="medium" @click="modifyDeviceNameDialog = false"
          style="padding: 8px 15px; background-color: #f5f5f5; border-color: #dcdfe6; color: #606266;">
          取 消
        </el-button>
        <el-button size="medium" type="primary" @click="ModifyNameAddrCommentCommit" style="padding: 8px 20px;">
          保 存
        </el-button>
      </div>
    </el-dialog>
    <!-- 修改床名字 END -->

    <!-- 添加单机设备 Start -->
    <!--    <el-dialog title="添加单机设备" :visible.sync="addDeviceNameDialog" width="500px">-->
    <!--      <el-form>-->
    <!--        <el-form-item label="设备串号：" label-width="100px" required>-->
    <!--          <el-input clearable v-model="addDeviceSN" autocomplete="off" maxlength="16"-->
    <!--                    show-word-limit>-->
    <!--            <el-button slot="append" type="primary" plain @click="GenSN">随机生成</el-button>-->
    <!--          </el-input>-->
    <!--        </el-form-item>-->

    <!--        <el-form-item label="设备编号：" label-width="100px" required>-->
    <!--          <el-input clearable v-model="addDeviceCID" autocomplete="off" maxlength="16"-->
    <!--                    show-word-limit>-->
    <!--            <el-button slot="append" type="primary" plain @click="GenCID">随机生成</el-button>-->
    <!--          </el-input>-->
    <!--        </el-form-item>-->

    <!--        <el-form-item label="客户名称：" label-width="100px" >-->
    <!--          <el-input clearable v-model="addDeviceName" autocomplete="off" maxlength="16"-->
    <!--                    show-word-limit>-->
    <!--          </el-input>-->
    <!--        </el-form-item>-->

    <!--        <el-form-item label="客户手机：" label-width="100px" >-->
    <!--          <el-input clearable v-model="addDevicePhone" autocomplete="off" maxlength="16"-->
    <!--                    show-word-limit>-->
    <!--          </el-input>-->
    <!--        </el-form-item>-->

    <!--        <el-form-item label="设备区域：" label-width="100px">-->
    <!--          <el-cascader-->
    <!--              style="width: 360px"-->
    <!--              size="large"-->
    <!--              :options="regionData"-->
    <!--              v-model="addSelectedArea">-->
    <!--          </el-cascader>-->
    <!--        </el-form-item>-->
    <!--        <el-form-item label="详细地址：" label-width="100px">-->
    <!--          <el-input clearable v-model="addAddress" autocomplete="off" maxlength="120"-->
    <!--                    show-word-limit></el-input>-->
    <!--        </el-form-item>-->

    <!--        <el-form-item label="设备备注：" label-width="100px">-->

    <!--        <el-input-->
    <!--            type="textarea"-->
    <!--            placeholder="请输入内容"-->
    <!--            v-model="addComments"-->
    <!--            :autosize="{ minRows: 3, maxRows: 6 }"-->
    <!--            maxlength="1000"-->
    <!--            show-word-limit-->
    <!--        >-->
    <!--        </el-input>-->
    <!--        </el-form-item>-->

    <!--      </el-form>-->

    <!--      <span style="padding-left: 9px">☆ 推荐串号和编号字母以'X'开头，和联网设备区分开</span>-->

    <!--      <div slot="footer" class="dialog-footer">-->
    <!--        <el-button @click="addDeviceNameDialog = false">取 消</el-button>-->
    <!--        <el-button type="primary" @click="AddOfflineDeviceCommit">添 加</el-button>-->
    <!--      </div>-->
    <!--    </el-dialog>-->
    <!-- 添加单机设备 END -->


    <el-dialog title="设备通讯协议" :visible.sync="DeviceModelDialog" width="410px">
      <el-form>
        <el-form-item label="设备协议：" label-width="100px">
          <el-select filterable v-model="ModelValue" placeholder="请选择">
            <el-option v-for="item in ModelList" :key="item.uid" :label="item.name" :value="item.uid">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="DeviceModelDialog = false">取 消</el-button>
        <el-button type="primary" @click="ModelCommit">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 设备Model END -->

    <el-dialog title="设定代理" :visible.sync="DeviceAllocateDialog" width="500px">
      <el-form>
        <el-form-item label="选择设备的代理商" label-width="160px">
          <el-select filterable v-model="AllocValue" placeholder="请选择">
            <el-option v-for="item in AllocList" :key="item.uid" :label="item.name" :value="item.uid">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="DeviceAllocateDialog = false">取 消</el-button>
        <el-button type="primary" @click="AllocateCommit">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 设备分配 END -->

    <!-- 导出报表 Start -->
    <el-dialog title="导出使用记录" :visible.sync="ExcelDialog" width="500px">

      <div class="block">
        <span style="margin-right: 5px">选择导出时间：</span>
        <el-date-picker v-model="excelTime" type="daterange" align="right" unlink-panels range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
        </el-date-picker>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="ExcelDialog = false">取 消</el-button>
        <el-button type="primary" @click="ExcelCommit">导 出</el-button>
      </div>
    </el-dialog>
    <!-- 导出报表 END -->

    <!-- 导出充次记录 +2024年1月29日 Start -->
    <el-dialog title="导出充次记录" :visible.sync="ChargeDialog" width="500px">

      <div class="block">
        <span style="margin-right: 5px">选择导出时间：</span>
        <el-date-picker v-model="excelTime" type="daterange" align="right" unlink-panels range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
        </el-date-picker>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="ChargeDialog = false">取 消</el-button>
        <el-button type="primary" @click="ExportChargeCommit">导 出</el-button>
      </div>
    </el-dialog>
    <!-- 导出充次记录 END -->

    <!-- 参数设置  AJC 艾灸床 AJC 艾灸床 AJC 艾灸床 AJC 艾灸床 AJC 艾灸床 AJC 艾灸床 AJC 艾灸床 AJC 艾灸床  Start -->
    <el-dialog :title="'远程参数设置 : ' + configName + '  (设备编号 : ' + configCID + ')'" :visible.sync="configDialogAJC"
      width="800px">

      <el-form ref="form" :model="configData" label-width="120px">
        <el-row :gutter="20">
          <!-- 工作时间设置 -->
          <el-col :span="8">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span style="font-size: 1.2em; text-align: center;">工作时间设置:</span>
              </div>
              <el-input-number v-model="configData.wktm" :min="10" :max="90" :step="5"></el-input-number>
              <el-button type="success" icon="el-icon-check" style="width: 100%; margin-top: 10px;"
                @click="DeviceConfigCommit('wktm', configData.wktm)">保存</el-button>
            </el-card>
          </el-col>

          <!-- 仓内温度设置 -->
          <el-col :span="8">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span style="font-size: 1.2em; text-align: center;">仓内温度设置:</span>
              </div>
              <el-input-number v-model="configData.uct" :min="30" :max="61" :step="5"></el-input-number>
              <el-button type="success" icon="el-icon-check" style="width: 100%; margin-top: 10px;"
                @click="DeviceConfigCommit('uct', configData.uct)">保存</el-button>
            </el-card>
          </el-col>

          <!-- 净化温度设置 -->
          <el-col :span="8">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span style="font-size: 1.2em; text-align: center;">净化温度设置:</span>
              </div>
              <el-input-number v-model="configData.pt" :min="350" :max="500" :step="10"></el-input-number>
              <el-button type="success" icon="el-icon-check" style="width: 100%; margin-top: 10px;"
                @click="DeviceConfigCommit('pt', configData.pt)">保存</el-button>
            </el-card>
          </el-col>


          <!-- 风速设置 -->
          <el-col :span="8" style="margin-top: 12px;">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span style="font-size: 1.2em; text-align: center;">风速设置:</span>
              </div>
              <el-input-number v-model="configData.fs" :min="1" :max="3" :step="1"></el-input-number>
              <el-button type="success" icon="el-icon-check" style="width: 100%; margin-top: 10px;"
                @click="DeviceConfigCommit('fs', configData.fs)">保存</el-button>
            </el-card>
          </el-col>

          <!-- 点火时长设置 -->
          <el-col :span="8" style="margin-top: 12px;">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span style="font-size: 1.2em; text-align: center;">点火时长设置:</span>
              </div>
              <el-input-number v-model="configData.htm" :min="60" :max="900" :step="10"></el-input-number>
              <el-button type="success" icon="el-icon-check" style="width: 100%; margin-top: 10px;"
                @click="DeviceConfigCommit('htm', configData.htm)">保存</el-button>
            </el-card>
          </el-col>

          <!-- 点火温度设置 -->
          <el-col :span="8" style="margin-top: 12px;">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span style="font-size: 1.2em; text-align: center;">点火温度设置:</span>
              </div>
              <el-input-number v-model="configData.ht" :min="200" :max="500" :step="10"></el-input-number>
              <el-button type="success" icon="el-icon-check" style="width: 100%; margin-top: 10px;"
                @click="DeviceConfigCommit('ht', configData.ht)">保存</el-button>
            </el-card>
          </el-col>
        </el-row>
      </el-form>
      <div style="background-color: #f9f9f9; padding: 15px; border-radius: 6px; margin-top: 20px;">
        <i style="color: #999; display: block; margin-bottom: 10px;">注意：所有设置仅在设备处于"在线"或"运行"状态时生效，离线状态下无法进行远程配置。</i>

        <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 15px;">
          <div>
            <el-button style="margin-right: 10px;" size="medium" icon="el-icon-download" type="warning" plain
              @click="DeviceTrun('sendsn')">重新编号</el-button>
            <el-button style="margin-right: 10px;" size="medium" icon="el-icon-delete" type="danger" plain
              @click="DeviceTrun('reset')">清空注册</el-button>
          </div>

          <div>
            <el-button size="medium" icon="el-icon-refresh" type="success" @click="RefleshConfig"
              style="margin-right: 15px;">刷新配置</el-button>
            <el-button size="medium" icon="el-icon-close" type="info"
              @click="configDialogAJC = false; onRefresh()">关闭</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 参数设置 END -->

    <!-- 参数设置  汗蒸床 HZC 汗蒸床 HZC 汗蒸床 HZC 汗蒸床 HZC 汗蒸床 HZC 汗蒸床 HZC 汗蒸床 HZC 汗蒸床 HZC  Start -->
    <el-dialog :title="'远程参数设置 : ' + configName + '  (设备编号 : ' + configCID + ')'" :visible.sync="configDialogHZC"
      width="900px">

      <!-----------------------------------right---style="border-left: 1px dashed darkgray"--------------------------------->
      <el-form ref="form" :model="configData" label-width="100px"
        style="background-color: #fff; border-radius: 8px; box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1); padding: 20px;">



        <!-- 第一行：工作时长 + 仓内温度 -->
        <div style="display: flex; gap: 20px; margin-bottom: 20px;">
          <el-card shadow="hover" style="width: calc(50% - 10px); padding: 15px;">
            <el-form-item label="工作时长:" style="margin-bottom: 15px;">
              <div style="display: flex; align-items: center;">
                <el-input-number v-model="configData.wt" :min="10" :max="90" :step="5"
                  style="flex: 1; margin-right: 10px;"></el-input-number>
                <el-button type="primary" icon="el-icon-check" @click="DeviceConfigCommit('wt', configData.wt)"
                  style="padding: 8px 15px;">确认</el-button>
              </div>
            </el-form-item>
          </el-card>

          <el-card shadow="hover" style="width: calc(50% - 10px); padding: 15px;">
            <el-form-item label="仓内温度:" style="margin-bottom: 15px;">
              <div style="display: flex; align-items: center;">
                <el-input-number v-model="configData.ut" :min="20" :max="80" :step="1"
                  style="flex: 1; margin-right: 10px;"></el-input-number>
                <el-button type="primary" icon="el-icon-check" @click="DeviceConfigCommit('ut', configData.ut)"
                  style="padding: 8px 15px;">确认</el-button>
              </div>
            </el-form-item>
          </el-card>
        </div>

        <!-- 第二行：水温设定 + 风速调节 -->
        <div style="display: flex; gap: 20px; margin-bottom: 20px;">
          <el-card shadow="hover" style="width: calc(50% - 10px); padding: 15px;">
            <el-form-item label="水温设定:" style="margin-bottom: 15px;">
              <div style="display: flex; align-items: center;">
                <el-input-number v-model="configData.ht" :min="30" :max="105" :step="5"
                  style="flex: 1; margin-right: 10px;"></el-input-number>
                <el-button type="primary" icon="el-icon-check" @click="DeviceConfigCommit('ht', configData.ht)"
                  style="padding: 8px 15px;">确认</el-button>
              </div>
            </el-form-item>
          </el-card>

          <el-card shadow="hover" style="width: calc(50% - 10px); padding: 15px;">
            <el-form-item label="风速调节:" style="margin-bottom: 15px;">
              <div style="display: flex; align-items: center;">
                <el-input-number v-model="configData.fp" :min="60" :max="100" :step="1"
                  style="flex: 1; margin-right: 10px;"></el-input-number>
                <el-button type="primary" icon="el-icon-check" @click="DeviceConfigCommit('fp', configData.fp)"
                  style="padding: 8px 15px;">确认</el-button>
              </div>
            </el-form-item>
          </el-card>
        </div>

        <div style="background-color: #f9f9f9; padding: 15px; border-radius: 6px; margin-top: 20px;">
          <i style="color: #999; display: block; margin-bottom: 10px;">注意：所有设置仅在设备处于"在线"或"运行"状态时生效，离线状态下无法进行远程配置。</i>

          <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 15px;">
            <div>
              <el-button style="margin-right: 10px;" size="medium" icon="el-icon-download" type="warning" plain
                @click="DeviceTrun('sendsn')">重新编号</el-button>
              <el-button style="margin-right: 10px;" size="medium" icon="el-icon-delete" type="danger" plain
                @click="DeviceTrun('reset')">清空注册</el-button>
            </div>

            <div>
              <el-button size="medium" icon="el-icon-refresh" type="success" @click="RefleshConfig"
                style="margin-right: 15px;">刷新配置</el-button>
              <el-button size="medium" icon="el-icon-close" type="info"
                @click="configDialogHZC = false; onRefresh()">关闭</el-button>
            </div>
          </div>
        </div>
      </el-form>
    </el-dialog>
    <!-- 参数设置 END -->

    <!-- 参数设置  LED(F3C1D) LED(F3C1D) LED(F3C1D) LED(F3C1D) LED(F3C1D) LED(F3C1D) LED(F3C1D)  Start -->
    <el-dialog :title="'远程参数设置 : ' + configName + '  (设备编号 : ' + configCID + ')'" :visible.sync="configDialogLED"
      width="900px">

      <el-form ref="form" :model="configData" label-width="100px"
        style="background-color: #fff; border-radius: 8px; box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1); padding: 20px;">

        <!-- 第一行：净化温度 + 点火温度 -->
        <div style="display: flex; gap: 20px; margin-bottom: 20px;">
          <el-card shadow="hover" style="width: calc(50% - 10px); padding: 15px;">
            <el-form-item label="净化温度:" style="margin-bottom: 15px;">
              <div style="display: flex; align-items: center;">
                <el-input-number v-model="configData.pt" :min="450" :max="500" :step="10"
                  style="flex: 1; margin-right: 10px;"></el-input-number>
                <el-button type="primary" icon="el-icon-check" @click="DeviceConfigCommit('jhtemp', configData.pt)"
                  style="padding: 8px 15px;">确认</el-button>
              </div>
            </el-form-item>
          </el-card>

          <el-card shadow="hover" style="width: calc(50% - 10px); padding: 15px;">
            <el-form-item label="点火温度:" style="margin-bottom: 15px;">
              <div style="display: flex; align-items: center;">
                <el-input-number v-model="configData.fw" :min="200" :max="450" :step="10"
                  style="flex: 1; margin-right: 10px;"></el-input-number>
                <el-button type="primary" icon="el-icon-check" @click="DeviceConfigCommit('firetemp', configData.fw)"
                  style="padding: 8px 15px;">确认</el-button>
              </div>
            </el-form-item>
          </el-card>
        </div>

        <!-- 第二行：仓内温度 + 点火时长 -->
        <div style="display: flex; gap: 20px; margin-bottom: 20px;">
          <el-card shadow="hover" style="width: calc(50% - 10px); padding: 15px;">
            <el-form-item label="仓内温度:" style="margin-bottom: 15px;">
              <div style="display: flex; align-items: center;">
                <el-input-number v-model="configData.uc" :min="30" :max="61" :step="1"
                  style="flex: 1; margin-right: 10px;"></el-input-number>
                <el-button type="primary" icon="el-icon-check" @click="DeviceConfigCommit('uct', configData.uc)"
                  style="padding: 8px 15px;">确认</el-button>
              </div>
            </el-form-item>
          </el-card>

          <el-card shadow="hover" style="width: calc(50% - 10px); padding: 15px;">
            <el-form-item label="点火时长:" style="margin-bottom: 15px;">
              <div style="display: flex; align-items: center;">
                <el-input-number v-model="configData.ft" :min="60" :max="600" :step="10"
                  style="flex: 1; margin-right: 10px;"></el-input-number>
                <el-button type="primary" icon="el-icon-check" @click="DeviceConfigCommit('firetime', configData.ft)"
                  style="padding: 8px 15px;">确认</el-button>
              </div>
            </el-form-item>
          </el-card>
        </div>

        <!-- 第三行：风速设置 -->
        <div style="display: flex; gap: 20px; margin-bottom: 20px;">
          <el-card shadow="hover" style="width: calc(50% - 10px); padding: 15px;">
            <el-form-item label="风速设置:" style="margin-bottom: 15px;">
              <div style="display: flex; align-items: center;">
                <el-input-number v-model="configData.fs" :min="1" :max="3" :step="1"
                  style="flex: 1; margin-right: 10px;"></el-input-number>
                <el-button type="primary" icon="el-icon-check" @click="DeviceConfigCommit('fs', configData.fs)"
                  style="padding: 8px 15px;">确认</el-button>
              </div>
            </el-form-item>
          </el-card>
        </div>

        <!-- 第四行：风速低 + 风速中 -->
        <div style="display: flex; gap: 20px; margin-bottom: 20px;">
          <el-card shadow="hover" style="width: calc(50% - 10px); padding: 15px;">
            <el-form-item label="风速低:" style="margin-bottom: 15px;">
              <div style="display: flex; align-items: center;">
                <el-input-number v-model="configData.l" :min="50" :max="100" :step="1"
                  style="flex: 1; margin-right: 10px;"></el-input-number>
                <el-button type="primary" icon="el-icon-check" @click="DeviceConfigCommit('fanl', configData.l)"
                  style="padding: 8px 15px;">确认</el-button>
              </div>
            </el-form-item>
          </el-card>

          <el-card shadow="hover" style="width: calc(50% - 10px); padding: 15px;">
            <el-form-item label="风速中:" style="margin-bottom: 15px;">
              <div style="display: flex; align-items: center;">
                <el-input-number v-model="configData.m" :min="50" :max="100" :step="1"
                  style="flex: 1; margin-right: 10px;"></el-input-number>
                <el-button type="primary" icon="el-icon-check" @click="DeviceConfigCommit('fanm', configData.m)"
                  style="padding: 8px 15px;">确认</el-button>
              </div>
            </el-form-item>
          </el-card>
        </div>

        <!-- 第五行：风速高 + 停机风速 -->
        <div style="display: flex; gap: 20px; margin-bottom: 20px;">
          <el-card shadow="hover" style="width: calc(50% - 10px); padding: 15px;">
            <el-form-item label="风速高:" style="margin-bottom: 15px;">
              <div style="display: flex; align-items: center;">
                <el-input-number v-model="configData.h" :min="50" :max="100" :step="1"
                  style="flex: 1; margin-right: 10px;"></el-input-number>
                <el-button type="primary" icon="el-icon-check" @click="DeviceConfigCommit('fanh', configData.h)"
                  style="padding: 8px 15px;">确认</el-button>
              </div>
            </el-form-item>
          </el-card>

          <el-card shadow="hover" style="width: calc(50% - 10px); padding: 15px;">
            <el-form-item label="停机风速:" style="margin-bottom: 15px;">
              <div style="display: flex; align-items: center;">
                <el-input-number v-model="configData.s" :min="50" :max="100" :step="1"
                  style="flex: 1; margin-right: 10px;"></el-input-number>
                <el-button type="primary" icon="el-icon-check" @click="DeviceConfigCommit('fanstop', configData.s)"
                  style="padding: 8px 15px;">确认</el-button>
              </div>
            </el-form-item>
          </el-card>
        </div>

        <div style="background-color: #f9f9f9; padding: 15px; border-radius: 6px; margin-top: 20px;">
          <i style="color: #999; display: block; margin-bottom: 10px;">注意：所有设置仅在设备处于"在线"或"运行"状态时生效，离线状态下无法进行远程配置。</i>

          <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 15px;">
            <el-button size="medium" icon="el-icon-setting" type="primary" plain @click="SetLEDDefaultConfig">预置风速</el-button>

            <div>
              <el-button size="medium" icon="el-icon-refresh" type="success" @click="RefleshConfig"
                style="margin-right: 15px;">刷新配置</el-button>
              <el-button size="medium" icon="el-icon-close" type="info"
                @click="configDialogLED = false; onRefresh()">关闭</el-button>
            </div>
          </div>
        </div>
      </el-form>
    </el-dialog>
    <!-- 参数设置 END -->

    <el-dialog :title="'设备定位 - ' + MapTitle + '       -->> 地址: ' + MapAddress" :visible.sync="MapDialog" width="1300px">
      <el-form :inline="true">


        <el-form-item>
          <el-radio-group v-model="MapSelect" @change="GetMapInfo">
            <el-radio-button label="设备定位"></el-radio-button>
            <el-radio-button label="标注定位"></el-radio-button>
            <el-radio-button label="手动标定位置"></el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="省市区域：">
          <el-cascader style="width: 210px" size="large" :options="regionData" v-model="mapSelectedArea">
          </el-cascader>
        </el-form-item>

        <el-form-item label="地址：">
          <el-input clearable style="width: 160px" v-model="MapAddressInput" placeholder="详细地址"></el-input>
        </el-form-item>

        <el-form-item vlabel="经纬度：">
          <el-input clearable style="width: 150px" v-model="MapMarked" placeholder="输入坐标"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="LocationMarkCommit">保存</el-button>
        </el-form-item>
      </el-form>
      <div class="block" style="border-top: 1px dashed #000;">
        <iframe :src="MapURL" frameborder="0" style="width: 100%; height: 650px;"></iframe>
      </div>

    </el-dialog>
    <!--    地图END-->
  </div>
</template>

<script>
import { MessageBox } from "element-ui";
import { codeToText, regionData } from 'element-china-area-data'

export default {
  data() {
    return {
      autoRefreshFlag: false, // 默认关闭自动刷新
      refreshTimer: null, // 定时器
      //page
      currPage: 1,
      currSize: 12,
      currTotal: 0,
      ordercheck: false,
      SNorCID: "sn",
      searchinput: "", // 用户名查找
      deviceinput: "",//按设备名查找
      searchsn: "",//按SN查找
      searchphone: "",//按手机号查找
      searchdls: "",
      searchuid: "",
      leinput: "",// 按剩余次数查找
      tbdata: [
      ],
      // uselect: [{
      //   value: '',
      //   label: '不限'
      // }],
      // usvalue: '',
      // sselect: [{
      //   value: '',
      //   label: '不限'
      // }, {
      //   value: '在线',
      //   label: '在线'
      // }, {
      //   value: '运行',
      //   label: '运行'
      // }, {
      //   value: '离线',
      //   label: '离线'
      // },
      //   {
      //   value: '飞行模式',
      //   label: '飞行模式'
      // }, {
      //   value: '单机',
      //   label: '单机'
      // }
      // ],
      // , {
      //   value: '禁用',
      //   label: '禁用'
      // }
      ssvalue: '',


      // 地图
      MapDialog: false,
      MapIsMarked: false,
      MapTitle: '',
      MapURL: '',
      MapLoc: {},
      MapTypeoptions: [{
        value: 'a',
        label: '高德地图'
      }, {
        value: 't',
        label: '腾讯地图(备用)'
      },
      ],
      MapSelect: '设备定位',
      MapSN: '',
      MapMarked: '',
      MapAddressInput: "",
      MapAddress: '',
      MapType: 'a',
      mapSelectedArea: [],

      // 充次前
      FlyModeFlag: false,
      FlyModeDisable: true,
      RechargeInfoCount: 0,
      RechargeInfoSystus: "",
      RechargeInfoFly: "",
      RechargeInfoUpdateTime: "",
      // 充次
      RechargeTimesDialog: false,
      RechargeEditor: "20",
      RechargeSN: "",
      RechargeComfirmOid: "",
      chargeLoading: false,
      chargedTxt: "充次前请与客户沟通，将屏幕切换到主界面（能看到剩余次数）",
      chargedType: "success",
      ChargeDayValue: '',
      OnlineForm: {
        old: "",
        edit: "",
        new: "",
      },
      ChargeCurr: {
        Name: "",
        Status: "",
        remday: '',
        exprday: '',
        SN: '',
        CID: '',
        Rssi: ""
      },
      // 离线充次
      OfflineDialog: false,
      OfflineCommited: false,
      OfflineMsg: "",//
      OffCode: '',
      OffResult: '',
      OffOid: '',
      OffCid: '',
      OffName: '',

      ChargeCommited: false,
      // 滤芯核销
      // FilterVerifyDialog: false,
      // FilterVerifySN: "",
      // FilterVerifyCID: "",
      // FilterVerifyName:"",
      // FilterVerifyData: [],
      // FilterVerifySearch:"",
      // 售后记录
      // ServiceDialog: false,
      // ServiceSN: "",
      // ServiceCID: "",
      // ServiceName:"",
      // ServiceData: [],
      // ServiceByID:"",
      // ServiceNUM:"",
      // ServiceForm:{},
      // ServiceWaiter:"",
      // 远程配置
      configDialogAJC: false,
      configDialogHZC: false,
      configDialogLED: false,
      configSN: "",
      configCID: "",
      configName: "",
      configData: {},
      runData: {},
      // 历史风机参数
      HistoryDataDialog: false,
      HistoryDataSN: "",
      HistoryDataCID: "",
      HistoryDataName: "",
      HistoryLoading: false,
      HistoryDataData: [],
      Hselect: [{
        value: 'heat',
        label: '加热温度'
      }, {
        value: 'pulse',
        label: '风机脉冲'
      }],
      // , {
      //   value: '禁用',
      //   label: '禁用'
      // }
      HSvalue: 'heat',
      HistoryTime: null,
      HistoryHeader:
      {
        time: '记录时间',
        parse: 'XXX',
      },
      // FilterVerifyDialog: false,
      // FilterVerifySN: "",
      // FilterVerifyCID: "",
      // FilterVerifyName:"",
      // FilterVerifyData: [],
      // FilterVerifySearch:"",

      // add device
      addDeviceNameDialog: false,
      addDeviceSN: "",
      addDevicePhone: "",
      addDeviceName: "",
      addDeviceCID: "",
      addComments: "",
      addAddress: "",
      addSelectedArea: [],


      // 修改名字
      modifyDeviceNameDialog: false,
      modifyEditor: "",
      modifyUserPhone: "",
      modifyComments: "",
      modifySN: "",
      modifyCID: "",
      modifyAddress: "",
      regionData,
      modifySelectedArea: [],
      // 设备分配
      DeviceAllocateDialog: false,
      AllocSN: "",
      AllocValue: "",
      AllocList: null,

      // 设备Model
      DeviceModelDialog: false,
      ModelSN: "",
      ModelValue: "",
      ModelList: null,

      // // 锁机
      // LockDialog: false,
      // LockSN: "",
      // LockName: "",
      // LockStatus: "",
      // LockID: "",
      // LockCid: "",
      // Lock: {
      //   reason:"",
      //   notes:"",
      //   operator:"",
      //   op_password:""
      // },
      // LockList: [{
      //   value: '1',
      //   label: '未授权使用'
      // }, {
      //   value: '2',
      //   label: '您已欠费'
      // }, {
      //   value: '3',
      //   label: '请补齐分期尾款'
      // }, {
      //   value: '4',
      //   label: '设备维护中（其他原因）'
      // }],

      // 导出报表
      ExcelDialog: false,
      excelTime: "",
      ExcelSN: "",
      ExcelCID: "",
      ExcelName: "",
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      pickerOptionsDay: {
        shortcuts: [{
          text: '3天',
          onClick(picker) {

            const start = new Date();
            start.setTime(start.getTime() + 3600 * 1000 * 24 * 3);
            picker.$emit('pick', start);
          }
        }, {
          text: '7天',
          onClick(picker) {

            const start = new Date();
            start.setTime(start.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', start);
          }
        }, {
          text: '1个月',
          onClick(picker) {

            const start = new Date();
            start.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
            picker.$emit('pick', start);
          }
        }, {
          text: '2个月',
          onClick(picker) {

            const start = new Date();
            start.setTime(start.getTime() + 3600 * 1000 * 24 * 61);
            picker.$emit('pick', start);
          }
        }, {
          text: '3个月',
          onClick(picker) {

            const start = new Date();
            start.setTime(start.getTime() + 3600 * 1000 * 24 * 91);
            picker.$emit('pick', start);
          }
        }, {
          text: '6个月',
          onClick(picker) {

            const start = new Date();
            start.setTime(start.getTime() + 3600 * 1000 * 24 * 183);
            picker.$emit('pick', start);
          }
        }, {
          text: '12个月',
          onClick(picker) {

            const start = new Date();
            start.setTime(start.getTime() + 3600 * 1000 * 24 * 365);
            picker.$emit('pick', start);
          }
        }]
      },
      orderHeader: {
        i: '序号',
        s: '启动时间',
        e: '停止时间',
        u: '工作时长/分钟',
        m: '备注',
      },
      orderList: [],
      //device list excel
      deviceHeader:
      {
        sn: '设备编号',
        dev: '设备名称',
        ph: '手机号',
        st: '状态',
        cnt: '剩余次数',
        // fc: '滤芯更换',
        cc: '充次计数',
        // svt: '售后次数',
        td: '今日次数',
        tt: '总计次数',
      },

      // 导出充次 + 2024年1月29日
      ChargeDialog: false,
      chargeorderHeader: {
        i: '系统单号',
        op: '操作者',
        type: '操作类型',
        status: '状态',
        before: '充值前次数',
        change: '充值次数',
        create_time: '操作时间',
        // transaction_id: '滤芯编号/离线编号',
        comments: '备注信息',
      },
      chargeOrderList: [],

      enen: false,
      pg_list: {
        charge_device: false,
        location: false,
        rename_device: false,
        // enable_device: false,
        bind_or_not: false,
        device_order_export: false,
        charge_order_export: false,
        infinite_times: false,
        delete_device: false,
        history_data: false,
        change_model: false,
      },
      btnwidth: 660,
    }
  },
  computed: {
    computedLabel() {
      // 根据HSvalue的值找到对应的label
      const selectedOption = this.Hselect.find(option => option.value === this.HSvalue);
      return selectedOption ? selectedOption.label : '';
    }
  },
  watch: {
    flag(val, oldVal) {

      //切换界面
      console.log('flag change: ' + val, oldVal)
      this.ssvalue = val

      setTimeout(() => {
        this.onRefreshOnce()
        console.log("this.refleshList()")
      }, 10)
    },
  },
  props: {
    flag: String,
  },
  created() {
    this.info = this.$store.state.userInfo

    // this.onGetVUList();
    this.PG_Query();
    this.onRefresh();

  },
  mounted() {
    if (this.autoRefreshFlag) {
      this.startRefreshTimer();
    }
  },
  beforeDestroy() {
    this.clearRefreshTimer();
  },
  methods: {
    MessageBox,
    handleSwitchChange(value) {
      if (value) {
        this.startRefreshTimer();
      } else {
        this.clearRefreshTimer();
      }
    },
    startRefreshTimer() {
      this.clearRefreshTimer(); // 清除之前的定时器
      this.refreshTimer = setInterval(() => {
        this.onRefresh();
      }, 10000); // 每5秒刷新一次
    },
    clearRefreshTimer() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
        this.refreshTimer = null;
      }
    },
    // 启动设备
    async DeviceTrun(turn) {
      let res = await this.$api.operator_device({
        sn: this.configSN + "",
        turn: turn + "",
      })
      console.log(res)
      if (res.status == 1) {
        this.$message({
          message: res.msg,
          type: 'success',
        })
      }
    },
    async DeviceTrunDirect(index, turn) {
      let res = await this.$api.operator_device({
        sn: this.tbdata[index].sn,
        turn: turn + "",
      })
      console.log(res)
      if (res.status == 1) {
        this.$message({
          message: res.msg,
          type: 'success',
        })
      }
    },
    // 导出报表
    ExportExcelDialog(index) {
      this.ExcelSN = this.tbdata[index].sn
      this.ExcelCID = this.tbdata[index].cid
      this.ExcelName = this.tbdata[index].dev
      this.ExcelDialog = true
    },

    async ExcelCommit() {
      let res = await this.$api.device_order_export({
        sn: this.ExcelSN,
        start: this.excelTime[0],
        end: this.excelTime[1]
      })
      console.log(res)
      if (res.status == 1) {
        this.$message({
          message: '导出成功',
          type: 'success',
        })
        this.orderList = res.data

        this.ExportOrderExcel()
      }

    },

    //////////////++++++++++++++////////// order excel //++++++++++++++++++++++//////////////////

    async ExportOrderExcel() {  //TODO V2
      console.log('ExportOrderExcel() ')
      //let dev = window.sessionStorage.getItem('devname')
      let name = "设备使用记录-" + this.ExcelName + '-' + this.ExcelCID + '(' + this.excelTime[0] + '-' + this.excelTime[1] + ').xlsx'
      let table = JSON.parse(JSON.stringify(this.orderList))
      let map = []
      let cols = Object.keys(this.orderHeader).length
      let widthMap = {}
      let end = String.fromCharCode(64 + parseInt(cols)) + (table.length + 1)
      // 加入表头
      table.unshift(this.orderHeader)
      // 数据字段过滤
      map = this.$Excel.filterExportData(table, [...Object.keys(this.orderHeader)])
      // 单元格宽度循环设置
      for (let x = 1; x <= cols; x++) {
        widthMap[String.fromCharCode(64 + parseInt(x))] = 120
      }
      widthMap['A'] = 60
      widthMap['E'] = 90

      let colConf = this.$Excel.makeColConfig({ ...widthMap }, 120)
      // 设置样式
      this.$Excel.setExportCellStyle(
        map,
        `A2:${end}`,
        {
          s: {
            fill: { bgColor: { indexed: 64 }, fgColor: { rgb: 'ebfade' } },
            font: { color: { rgb: '000000' } },
            alignment: { horizontal: 'center', vertical: 'center' },
          },
        },
        function (
          cell,
          newCell,
          row,
          config,
          currentRow,
          currentCol,
          fieldKey
        ) {
          console.log(row, config, currentCol, fieldKey)
          // 回调参数，cell:原有数据，newCell:根据批量设置规则自动生成的样式，row:所在行数据，config:传入的配置,currentRow:当前行索引,currentCol:当前列索引，fieldKey:当前字段索引
          return currentRow % 2 === 0 ? newCell : cell // 隔行隔列上色
        }
      )
      this.$Excel.setExportCellStyle(
        map,
        `A2:${end}`,
        {
          s: {
            font: { color: { rgb: '000000' } },
            alignment: { horizontal: 'center', vertical: 'center' },
          },
        },
        function (
          cell,
          newCell,
          row,
          config,
          currentRow,
          currentCol,
          fieldKey
        ) {
          console.log(row, config, currentCol, fieldKey)
          // 回调参数，cell:原有数据，newCell:根据批量设置规则自动生成的样式，row:所在行数据，config:传入的配置,currentRow:当前行索引,currentCol:当前列索引，fieldKey:当前字段索引
          return currentRow % 2 === 1 ? newCell : cell // 隔行隔列上色
        }
      )
      // 设置样式
      this.$Excel.setExportCellStyle(
        map,
        `A1:${String.fromCharCode(64 + parseInt(cols))}1`,
        {
          s: {
            fill: { bgColor: { indexed: 64 }, fgColor: { rgb: '135573' } },
            font: { color: { rgb: 'ffffff' } },
            alignment: { horizontal: 'center', vertical: 'center' },
          },
        },
        function (
          cell,
          newCell,
          row,
          config,
          currentRow,
          currentCol,
          fieldKey
        ) {
          console.log(row, config, currentCol, fieldKey)
          return currentRow === 0 ? newCell : cell // 隔行隔列上色
        }
      )
      // 导出excel
      this.$Excel.exportExcel(map, name, 'xlsx', {
        extend: {
          '!cols': colConf,
        },
      })
    }, //end order excel
    // ------------------------------------------------------------------------------------------------------------

    // 导出充次记录 + 2024年1月29日
    ExportChargeDialog(index) {
      this.ExcelSN = this.tbdata[index].sn
      this.ExcelCID = this.tbdata[index].cid
      this.ExcelName = this.tbdata[index].dev
      this.ChargeDialog = true
    },

    async ExportChargeCommit() {  // + 2024年1月29日

      let res = await this.$api.charge_order_export({
        sn: this.ExcelCID,
        start: this.excelTime[0],
        end: this.excelTime[1]
      })
      console.log(res)
      if (res.status == 1) {
        this.$message({
          message: '导出成功',
          type: 'success',
        })
        this.chargeOrderList = res.data

        this.ExportChargeOrderExcel()
      }

    },

    async ExportChargeOrderExcel() {  // + 2024年1月29日
      console.log('ExportChargeOrderExcel() ')
      //let dev = window.sessionStorage.getItem('devname')
      let name = "设备充次记录-" + this.ExcelName + '(' + this.excelTime[0] + '-' + this.excelTime[1] + ').xlsx'
      let table = JSON.parse(JSON.stringify(this.chargeOrderList))
      let map = []
      let cols = Object.keys(this.chargeorderHeader).length
      let widthMap = {}
      let end = String.fromCharCode(64 + parseInt(cols)) + (table.length + 1)
      // 加入表头
      table.unshift(this.chargeorderHeader)
      // 数据字段过滤
      map = this.$Excel.filterExportData(table, [...Object.keys(this.chargeorderHeader)])
      // 单元格宽度循环设置
      for (let x = 1; x <= cols; x++) {
        widthMap[String.fromCharCode(64 + parseInt(x))] = 80
      }
      widthMap['A'] = 120
      widthMap['B'] = 90
      widthMap['C'] = 80
      widthMap['G'] = 110
      widthMap['H'] = 200

      let colConf = this.$Excel.makeColConfig({ ...widthMap }, 110)
      // 设置样式
      this.$Excel.setExportCellStyle(
        map,
        `A2:${end}`,
        {
          s: {
            fill: { bgColor: { indexed: 64 }, fgColor: { rgb: 'ebfade' } },
            font: { color: { rgb: '000000' } },
            alignment: { horizontal: 'center', vertical: 'center' },
          },
        },
        function (
          cell,
          newCell,
          row,
          config,
          currentRow,
          currentCol,
          fieldKey
        ) {
          console.log(row, config, currentCol, fieldKey)
          // 回调参数，cell:原有数据，newCell:根据批量设置规则自动生成的样式，row:所在行数据，config:传入的配置,currentRow:当前行索引,currentCol:当前列索引，fieldKey:当前字段索引
          return currentRow % 2 === 0 ? newCell : cell // 隔行隔列上色
        }
      )
      this.$Excel.setExportCellStyle(
        map,
        `A2:${end}`,
        {
          s: {
            font: { color: { rgb: '000000' } },
            alignment: { horizontal: 'center', vertical: 'center' },
          },
        },
        function (
          cell,
          newCell,
          row,
          config,
          currentRow,
          currentCol,
          fieldKey
        ) {
          console.log(row, config, currentCol, fieldKey)
          // 回调参数，cell:原有数据，newCell:根据批量设置规则自动生成的样式，row:所在行数据，config:传入的配置,currentRow:当前行索引,currentCol:当前列索引，fieldKey:当前字段索引
          return currentRow % 2 === 1 ? newCell : cell // 隔行隔列上色
        }
      )
      // 设置样式
      this.$Excel.setExportCellStyle(
        map,
        `A1:${String.fromCharCode(64 + parseInt(cols))}1`,
        {
          s: {
            fill: { bgColor: { indexed: 64 }, fgColor: { rgb: '107c41' } },
            font: { color: { rgb: 'ffffff' } },
            alignment: { horizontal: 'center', vertical: 'center' },
          },
        },
        function (
          cell,
          newCell,
          row,
          config,
          currentRow,
          currentCol,
          fieldKey
        ) {
          console.log(row, config, currentCol, fieldKey)
          return currentRow === 0 ? newCell : cell // 隔行隔列上色
        }
      )
      // 导出excel
      this.$Excel.exportExcel(map, name, 'xlsx', {
        extend: {
          '!cols': colConf,
        },
      })
    }, //end order excel
    // ------------------------------------------------------------------------------------------------------------


    // 启用禁用设备

    // async UnlockCommit(index) {
    //   let op = localStorage.getItem('op');
    //   if (op === null || op === '') {
    //     op = this.info.name;
    //     localStorage.setItem('op', op);
    //   }
    //   let res = await this.$api.lock_device({
    //     sn: this.tbdata[index].sn+"",
    //     op:op,
    //     code:"0",
    //     reason:"后台解锁",
    //   })
    //   if (res.status == 1) {
    //     this.$message({
    //       message: '操作成功',
    //       type: 'success',
    //     })
    //     this.onRefresh()
    //   }
    // },
    // async EnableDisableDevice(index, en) {
    //   let res = await this.$api.enable_device({
    //     sn: this.tbdata[index].sn,
    //     en: en,
    //   })
    //   console.log(res)
    //   if (res.status == 1) {
    //     this.$message({
    //       message: '操作成功',
    //       type: 'success',
    //     })
    //     this.onRefresh();
    //   }
    // },
    // 充次弹窗
    // ChargeChange(e) {
    //   this.OnlineForm.new = parseInt(this.OnlineForm.old) + parseInt(e)
    // },
    // 地图
    async OpenMapDialog(index) {
      this.MapURL = ''
      this.MapTitle = this.tbdata[index].dev
      this.MapSN = this.tbdata[index].sn
      this.MapMarked = ''
      this.MapAddressInput = ""
      let res = await this.$api.get_location({
        type: 'auto',///this.MapSelect,
        sn: this.MapSN
      })
      console.log(res)
      if (res.status == 1) {
        this.MapURL = res.data.url
        this.MapAddress = res.data.addr
        this.MapSelect = res.data.type
        this.MapAddressInput = res.data.address
        this.mapSelectedArea = res.data.area
        this.MapMarked = res.data.marked
      }
      this.MapDialog = true
    },
    async GetMapInfo() {
      this.MapURL = ''
      this.MapMarked = ''
      this.MapMarked = ''
      this.MapAddressInput = ""
      let res = await this.$api.get_location({
        type: this.MapSelect,
        sn: this.MapSN
      })
      console.log(res)
      if (res.status == 1) {
        this.MapURL = res.data.url
        this.MapAddress = res.data.addr
        this.MapSelect = res.data.type
        this.MapAddressInput = res.data.address
        this.mapSelectedArea = res.data.area
        this.MapMarked = res.data.marked
      }
    },
    async LocationMarkCommit() {
      let res = await this.$api.location_commit({
        sn: this.MapSN + "",
        mark: this.MapMarked + "",
        area: this.mapSelectedArea,
        area_name: [codeToText[this.mapSelectedArea[0]], codeToText[this.mapSelectedArea[1]], codeToText[this.mapSelectedArea[2]]],
        address: this.MapAddressInput + "",
      })
      console.log(res)
      if (res.status == 1) {
        this.$notify({
          title: '成功',
          message: '标注成功',
          type: 'success'
        });
        this.MapSelect = '标注定位'
        this.GetMapInfo()
      }
    },
    // MapGenUrl(){
    //     if(this.MapType == "t"){
    //       this.MapURL = `https://apis.map.qq.com/uri/v1/marker?marker=coord:${this.MapLoc.lat},${this.MapLoc.lng};title:${this.MapTitle}`
    //     } else  if(this.MapType == "a"){
    //       this.MapURL = `https://uri.amap.com/marker?position=${this.MapLoc.lng},${this.MapLoc.lat}&name=${this.MapTitle}&coordinate=wgs84&callnative=0`
    //     }else  if(this.MapType == "b"){
    //       this.MapURL = `http://api.map.baidu.com/marker?location=${this.MapLoc.lat},${this.MapLoc.lng}&title=${this.MapTitle}&output=html`
    //     }else {
    //       this.MapURL = `https://uri.amap.com/marker?position=${this.MapLoc.lng},${this.MapLoc.lat}&name=${this.MapTitle}&coordinate=wgs84&callnative=0`
    //     }
    // },
    async handleFlyModeChange(value) {
      if (value) {
        console.log("turn on")
        await this.$api.turn_flymode({
          sn: this.RechargeSN,
          turn: "fly"
        })
      } else {
        console.log("turn off")
        await this.$api.turn_flymode({
          sn: this.RechargeSN,
          turn: "off"
        })
      }
    },
    async RefleshChargeInfo() {
      let res = await this.$api.charge_info({
        sn: this.RechargeSN
      })
      console.log(res)
      if (res.status == 1) {
        this.RechargeInfoCount = res.data.counts
        this.RechargeInfoSystus = res.data.sys_status
        this.RechargeInfoFly = res.data.fly
        if (this.RechargeInfoFly == "fly") {
          this.FlyModeFlag = true
        } else {
          this.FlyModeFlag = false
        }
        if (this.RechargeInfoFly == "x") {
          this.FlyModeDisable = true
        } else {
          this.FlyModeDisable = false
        }
        this.RechargeInfoUpdateTime = res.data.time
        this.OnlineForm.old = this.RechargeInfoCount
        this.ChargeCurr.remday = res.data.remday
        this.ChargeCurr.exprday = res.data.exprday
        // this.OnlineForm.new = parseInt(this.OnlineForm.old) + 55
      }
    },
    OpenRechargeDialog(index) {
      this.ChargeCurr.SN = this.tbdata[index].sn
      this.ChargeCurr.Name = this.tbdata[index].dev
      this.ChargeCurr.CID = this.tbdata[index].cid
      this.ChargeCurr.Status = this.tbdata[index].st
      this.OnlineForm.old = this.tbdata[index].cnt
      this.ChargeCurr.remday = this.tbdata[index].remain_day
      this.ChargeCurr.exprday = this.tbdata[index].expr
      this.OnlineForm.edit = 300
      //this.OnlineForm.new = parseInt(this.OnlineForm.old) + 55
      this.RechargeSN = this.tbdata[index].sn
      this.RechargeTimesDialog = true
      this.ChargeCommited = false
      this.chargedTxt = "充次前请与客户沟通，将屏幕切换到主界面（能看到剩余次数,方便确认充上）"
      this.chargedType = "success"

      this.RefleshChargeInfo()

      let r = parseInt(this.tbdata[index].r, 10);
      if (r > 26) {
        this.ChargeCurr.Rssi = '极好';
      } else if (r >= 20 && r <= 26) {
        this.ChargeCurr.Rssi = '较好';
      } else if (r >= 15 && r <= 20) {
        this.ChargeCurr.Rssi = '一般';
      } else if (r >= 11 && r <= 14) {
        this.ChargeCurr.Rssi = '较差';
      } else {
        this.ChargeCurr.Rssi = '极差';
      }
      // this.ChargeCurr.Rssi = this.ChargeCurr.Rssi+ ' (信号值='+this.tbdata[index].r+')';

      if (this.tbdata[index].st == "离线") {
        this.ChargeCurr.Rssi = '无信号（或关机）';
        this.$message({
          message: '4G充次时需确保设备在线，请等待设备上线后刷新或使用密码充次',
          type: 'warning'
        });
      }
    },

    // OpenFilterVerifyDialog(index) {
    //   this.FilterVerifyName = this.tbdata[index].na
    //   this.FilterVerifySN = this.tbdata[index].sn
    //   this.FilterVerifyCID = this.tbdata[index].cid
    //   this.FilterVerifyDialog = true
    // },

    OpenConfigDialog(index) {
      this.configName = this.tbdata[index].dev
      this.configSN = this.tbdata[index].sn
      this.configCID = this.tbdata[index].cid
      this.RefleshConfig();
      if (this.tbdata[index].mod == "F0C1T" || this.tbdata[index].mod == "F0C9T"|| this.tbdata[index].mod == "F0C5T" || this.tbdata[index].mod == "F0C1D")
        this.configDialogAJC = true
      if (this.tbdata[index].mod == "F0C2T")
        this.configDialogHZC = true
      if (this.tbdata[index].mod == "F3C1D")
        this.configDialogLED = true
    },
    // OpenHistoryDataDialog() {
    //   this.configDialog = false
    //   this.HistoryDataDialog = true
    //   this.HistoryDataSN = this.configSN
    //   this.HistoryDataCID = this.configCID
    //   this.HistoryDataName = this.configName
    // },
    // async onRefreshHistory() {
    //   this.HistoryLoading = true
    //   this.HistoryDataData = []
    //   try {
    //     let res = await this.$api_log.heat_pulse({
    //       sn: this.HistoryDataSN + "",
    //       type: this.HSvalue,
    //       start: this.HistoryTime[0] + "",
    //       end: this.HistoryTime[1] + "",
    //       reverse: false,
    //       db: "latest",
    //       access: "xxx"
    //     })
    //     this.HistoryLoading = false

    //     // console.log(res)
    //     if (res.status == 1) {
    //       this.HistoryDataData = res.data
    //     }
    //   } catch (error) {
    //     this.HistoryLoading = false
    //   }
    // },


    // async OpenLockDialog(index){
    //   this.LockSN = this.tbdata[index].sn
    //   this.LockCid = this.tbdata[index].cid
    //   this.LockName = this.tbdata[index].na
    //   this.LockStatus = this.tbdata[index].st //get
    //
    //   this.Lock.operator = "" ;
    //   this.Lock.reason="" //get
    //   this.Lock.notes="" //get
    //   this.Lock.LockID=0 //get
    //   let res = await this.$api.get_lock_info({
    //     sn: this.LockSN,
    //   })
    //   console.log(res)
    //   if (res.status == 1) {
    //     this.LockID = res.lock_id //get
    //     this.Lock.reason=res.lock_js.Reason //get
    //     this.Lock.notes=res.lock_js.Notes //get
    //     this.Lock.operator = res.lock_js.Operator
    //   }
    //   this.Lock.op_password=""
    //   this.LockDialog = true
    // },
    // // 锁机
    // async LockCommit(en) {
    //   let res = await this.$api.lock_device({
    //     op:this.Lock.operator+"",
    //     sn: this.LockSN+"",
    //     uid:""+this.info.uid,
    //     en: en+"",
    //     reason:this.Lock.reason+"",
    //     op_password:this.Lock.op_password+"",
    //     notes:this.Lock.notes+"",
    //   })
    //   if (res.status == 1) {
    //     this.$alert(res.msg, '操作成功', {
    //       confirmButtonText: '确定',
    //       type: 'success'
    //     });
    //   }
    // },

    // OpenServiceDialog(index){
    //   this.ServiceName = this.tbdata[index].na
    //   this.ServiceSN = this.tbdata[index].sn
    //   this.ServiceCID = this.tbdata[index].cid
    //   this.ServiceByID = ""
    //   this.RefleshServiceList();
    //   this.ServiceDialog = true
    // },

    async CreateServiceOrder() {
      let op = localStorage.getItem('op');
      if (op === null || op === '') {
        op = this.info.name;
        localStorage.setItem('op', op);
      }
      let res = await this.$api.create_server_order({
        sn: this.ServiceSN,
        op: op,
      })
      if (res.status == 1) {
        this.RefleshServiceList()
      }
    },
    async EditService(index) {
      this.ServiceByID = this.ServiceData[index].id
      this.ServiceNUM = this.ServiceData[index].s

      let res = await this.$api.service_detail({
        id: this.ServiceByID
      })
      console.log(res)
      if (res.status == 1) {
        console.log(res.data)
        this.ServiceForm = res.data

        if (this.ServiceWaiter == "") {
          this.ServiceWaiter = localStorage.getItem('op');
          if (this.ServiceWaiter === null || this.ServiceWaiter === '') {
            this.ServiceWaiter = this.info.name;
          }
        }
        localStorage.setItem('op', this.ServiceWaiter);
      }
    },
    /////////////////////////////////////////// excel //////////////////////////////////////////////////
    ExportHistoryExcel() {
      console.log('exportExcel() ')
      const selectedOption = this.Hselect.find(option => option.value === this.HSvalue);
      this.HistoryHeader.parse = selectedOption.label
      //let dev = window.sessionStorage.getItem('devname')
      let formattedDate = this.HistoryTime[0] + "~" + this.HistoryTime[1]
      let name = this.HistoryDataName + "(" + this.HistoryDataCID + ")" + this.HistoryHeader.parse + "历史记录" + formattedDate + '.xlsx';
      let table = JSON.parse(JSON.stringify(this.HistoryDataData))
      let map = []
      let cols = Object.keys(this.HistoryHeader).length
      let widthMap = {}
      let end = String.fromCharCode(64 + parseInt(cols)) + (table.length + 1)
      // 加入表头
      table.unshift(this.HistoryHeader)
      // 数据字段过滤
      map = this.$Excel.filterExportData(table, [...Object.keys(this.HistoryHeader)])
      // 单元格宽度循环设置
      for (let x = 1; x <= cols; x++) {
        widthMap[String.fromCharCode(64 + parseInt(x))] = 70
      }
      widthMap['A'] = 200
      widthMap['B'] = 120

      let colConf = this.$Excel.makeColConfig({ ...widthMap }, 70)
      // 设置样式
      this.$Excel.setExportCellStyle(
        map,
        `A2:${end}`,
        {
          s: {
            fill: { bgColor: { indexed: 64 }, fgColor: { rgb: 'ebfade' } },
            font: { color: { rgb: '000000' } },
            alignment: { horizontal: 'center', vertical: 'center' },
          },
        },
        function (
          cell,
          newCell,
          row,
          config,
          currentRow,
          currentCol,
          fieldKey
        ) {
          console.log(row, config, currentCol, fieldKey)
          // 回调参数，cell:原有数据，newCell:根据批量设置规则自动生成的样式，row:所在行数据，config:传入的配置,currentRow:当前行索引,currentCol:当前列索引，fieldKey:当前字段索引
          return currentRow % 2 === 0 ? newCell : cell // 隔行隔列上色
        }
      )
      this.$Excel.setExportCellStyle(
        map,
        `A2:${end}`,
        {
          s: {
            font: { color: { rgb: '000000' } },
            alignment: { horizontal: 'center', vertical: 'center' },
          },
        },
        function (
          cell,
          newCell,
          row,
          config,
          currentRow,
          currentCol,
          fieldKey
        ) {
          console.log(row, config, currentCol, fieldKey)
          // 回调参数，cell:原有数据，newCell:根据批量设置规则自动生成的样式，row:所在行数据，config:传入的配置,currentRow:当前行索引,currentCol:当前列索引，fieldKey:当前字段索引
          return currentRow % 2 === 1 ? newCell : cell // 隔行隔列上色
        }
      )
      // 设置样式
      this.$Excel.setExportCellStyle(
        map,
        `A1:${String.fromCharCode(64 + parseInt(cols))}1`,
        {
          s: {
            fill: { bgColor: { indexed: 64 }, fgColor: { rgb: '135573' } },
            font: { color: { rgb: 'ffffff' } },
            alignment: { horizontal: 'center', vertical: 'center' },
          },
        },
        function (
          cell,
          newCell,
          row,
          config,
          currentRow,
          currentCol,
          fieldKey
        ) {
          console.log(row, config, currentCol, fieldKey)
          return currentRow === 0 ? newCell : cell // 隔行隔列上色
        }
      )
      // 导出excel
      this.$Excel.exportExcel(map, name, 'xlsx', {
        extend: {
          '!cols': colConf,
        },
      })
    },
    ExportDeviceExcel() {
      console.log('exportExcel() ')
      //let dev = window.sessionStorage.getItem('devname')
      let currentDate = new Date();
      let formattedDate = currentDate.toLocaleString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '年') + '日';
      let name = "设备列表导出-" + formattedDate + '.xlsx';
      let table = JSON.parse(JSON.stringify(this.tbdata))
      let map = []
      let cols = Object.keys(this.deviceHeader).length
      let widthMap = {}
      let end = String.fromCharCode(64 + parseInt(cols)) + (table.length + 1)
      // 加入表头
      table.unshift(this.deviceHeader)
      // 数据字段过滤
      map = this.$Excel.filterExportData(table, [...Object.keys(this.deviceHeader)])
      // 单元格宽度循环设置
      for (let x = 1; x <= cols; x++) {
        widthMap[String.fromCharCode(64 + parseInt(x))] = 70
      }
      widthMap['A'] = 100
      widthMap['B'] = 120
      widthMap['C'] = 120

      let colConf = this.$Excel.makeColConfig({ ...widthMap }, 70)
      // 设置样式
      this.$Excel.setExportCellStyle(
        map,
        `A2:${end}`,
        {
          s: {
            fill: { bgColor: { indexed: 64 }, fgColor: { rgb: 'ebfade' } },
            font: { color: { rgb: '000000' } },
            alignment: { horizontal: 'center', vertical: 'center' },
          },
        },
        function (
          cell,
          newCell,
          row,
          config,
          currentRow,
          currentCol,
          fieldKey
        ) {
          console.log(row, config, currentCol, fieldKey)
          // 回调参数，cell:原有数据，newCell:根据批量设置规则自动生成的样式，row:所在行数据，config:传入的配置,currentRow:当前行索引,currentCol:当前列索引，fieldKey:当前字段索引
          return currentRow % 2 === 0 ? newCell : cell // 隔行隔列上色
        }
      )
      this.$Excel.setExportCellStyle(
        map,
        `A2:${end}`,
        {
          s: {
            font: { color: { rgb: '000000' } },
            alignment: { horizontal: 'center', vertical: 'center' },
          },
        },
        function (
          cell,
          newCell,
          row,
          config,
          currentRow,
          currentCol,
          fieldKey
        ) {
          console.log(row, config, currentCol, fieldKey)
          // 回调参数，cell:原有数据，newCell:根据批量设置规则自动生成的样式，row:所在行数据，config:传入的配置,currentRow:当前行索引,currentCol:当前列索引，fieldKey:当前字段索引
          return currentRow % 2 === 1 ? newCell : cell // 隔行隔列上色
        }
      )
      // 设置样式
      this.$Excel.setExportCellStyle(
        map,
        `A1:${String.fromCharCode(64 + parseInt(cols))}1`,
        {
          s: {
            fill: { bgColor: { indexed: 64 }, fgColor: { rgb: '135573' } },
            font: { color: { rgb: 'ffffff' } },
            alignment: { horizontal: 'center', vertical: 'center' },
          },
        },
        function (
          cell,
          newCell,
          row,
          config,
          currentRow,
          currentCol,
          fieldKey
        ) {
          console.log(row, config, currentCol, fieldKey)
          return currentRow === 0 ? newCell : cell // 隔行隔列上色
        }
      )
      // 导出excel
      this.$Excel.exportExcel(map, name, 'xlsx', {
        extend: {
          '!cols': colConf,
        },
      })
    },
    // async CommitOfflineCode() {
    //   let res = await this.$api.offline_confirm({
    //     cid: this.OffCid + "",
    //     oid: this.OffOid + "",
    //   })
    //   console.log(res)
    //   if (res.status == 1) {
    //     this.$message({
    //       message: res.msg,
    //       type: 'success',
    //     })
    //     this.OfflineDialog = false
    //     this.onRefresh()
    //   }
    // },
    // async GetOfflineCode() {
    //   let op = localStorage.getItem('op');
    //   if (op === null || op === '') {
    //     op = this.info.name;
    //     localStorage.setItem('op', op);
    //   }
    //   let res = await this.$api.offline_charge_record({
    //     offcode: this.OffCode + "",
    //     op: op,
    //   })
    //   console.log(res)
    //   if (res.status == 1) {
    //     this.OffResult = res.code
    //     this.OffOid = res.oid
    //     this.OffCid = res.cid
    //     this.OffName = res.name
    //     this.OfflineMsg = res.msg
    //     this.OfflineCommited = true
    //   }
    // },
    // // 确认充次
    // async RechargeConfirmCommit() {
    //   let res = await this.$api.charge_confirm({
    //     sn: this.RechargeSN + "",
    //     oid: this.RechargeComfirmOid + "",
    //   })
    //   console.log(res)
    //   if (res.status == 1) {
    //     this.$message({
    //       message: res.msg,
    //       type: 'success',
    //     })
    //     this.RechargeTimesDialog = false
    //     this.onRefresh()
    //   }
    // },
    CloseRechargeDialog() {
      this.RechargeTimesDialog = false
      this.onRefresh()
    },
    // 充次
    async RechargeCommit() {
      this.chargeLoading = true
      let op = localStorage.getItem('op');
      if (op === null || op === '') {
        op = this.info.name;
        localStorage.setItem('op', op);
      }
      try {
        let res = await this.$api.charge_device({
          sn: this.RechargeSN + "",
          op: op,
          times: this.OnlineForm.edit + "",
        })
        console.log(res)
        this.chargeLoading = false
        if (res.status == 1) {
          this.$message({
            message: res.msg,
            type: 'success',
          })
          this.RechargeComfirmOid = res.oid
          this.ChargeCommited = true
          this.RefleshChargeInfo()
        }
      } catch (error) {
        // this.$message({
        //   message: "充次失败，建议检查设备在线和信号情况",
        //   type: 'error',
        // })
        this.chargedType = "error"
        this.chargedTxt = "充次失败，建议检查设备在线和信号情况，并点击“再次充次”"
        this.chargeLoading = false;
      }
    },
    // 充时间
    async RechargeDayCommit() {
      this.chargeLoading = true
      try {
        let res = await this.$api.charge_day({
          sn: this.RechargeSN + "",
          date: this.ChargeDayValue + "",
        })
        console.log(res)
        this.chargeLoading = false
        if (res.status == 1) {
          this.$message({
            message: res.msg,
            type: 'success',
          })
          this.RefleshChargeInfo()
        }
      } catch (error) {
        // this.$message({
        //   message: "日期设置失败",
        //   type: 'error',
        // })
        this.chargeLoading = false;
      }
    },
    async RechargeNullDayCommit() {
      this.chargeLoading = true
      try {
        let res = await this.$api.charge_day({
          sn: this.RechargeSN + "",
          date: "null",
        })
        console.log(res)
        this.chargeLoading = false
        if (res.status == 1) {
          this.$message({
            message: res.msg,
            type: 'success',
          })
          this.RefleshChargeInfo()
        }
      } catch (error) {
        this.$message({
          message: "日期设置失败",
          type: 'error',
        })
        this.chargeLoading = false;
      }
    },
    // 新建单机设备
    AddOfflineDeviceDialog() {
      this.addDevicePhone = ""
      this.addDeviceSN = ""
      this.addDeviceCID = ""
      this.addDeviceName = ""
      this.addComments = ""
      this.addAddress = ""
      this.addSelectedArea = []
      this.addDeviceNameDialog = true
    },
    // async AddOfflineDeviceCommit() {
    //   let res = await this.$api.add_offline_device({
    //     sn: this.addDeviceSN,
    //     cid: this.addDeviceCID,
    //     name: this.addDeviceName,
    //     phone: this.addDevicePhone,
    //     comm: this.addComments,
    //     area: this.addSelectedArea,
    //     area_name: [codeToText[this.addSelectedArea[0]], codeToText[this.addSelectedArea[1]], codeToText[this.addSelectedArea[2]]],
    //     address: this.addAddress,
    //   })
    //   console.log(res)
    //   if (res.status == 1) {
    //     this.$message({
    //       message: '设备添加成功',
    //       type: 'success',
    //     })
    //     this.onRefresh();
    //   }
    //   // this.modifyDeviceNameDialog = false
    // },
    // 修改名字
    async OpenModifyDialog(index) {
      this.modifyEditor = this.tbdata[index].dev
      this.modifyUserPhone = this.tbdata[index].ph
      this.modifySN = this.tbdata[index].sn
      this.modifyCID = this.tbdata[index].cid
      this.modifyComments = ""
      this.modifyAddress = ""
      let res = await this.$api.get_comments_and_addr({
        sn: this.modifySN,
      })
      console.log(res)
      if (res.status == 1) {
        this.modifyComments = res.comments
        this.modifyAddress = res.addr.address
        this.modifySelectedArea = res.addr.area
      }
      this.modifyDeviceNameDialog = true
    },
    async ModifyNameAddrCommentCommit() {
      let res = await this.$api.edit_device_info({
        sn: this.modifySN,
        rename: this.modifyEditor,
        phone: this.modifyUserPhone,
        comm: this.modifyComments,
        area: this.modifySelectedArea,
        area_name: [codeToText[this.modifySelectedArea[0]], codeToText[this.modifySelectedArea[1]], codeToText[this.modifySelectedArea[2]]],
        address: this.modifyAddress,
      })
      console.log(res)
      if (res.status == 1) {
        this.$message({
          message: '修改成功',
          type: 'success',
        })
        this.onRefresh();
      }
      this.modifyDeviceNameDialog = false
    },
    // model设置
    async OpenChangeModelDialog(index) {
      // console.log(this.pg_list.change_model)  
      if (this.pg_list.change_model) {
        this.ModelSN = this.tbdata[index].sn

        let res = await this.$api.device_model_list({
          sn: this.ModelSN
        })
        console.log(res)
        if (res.status == 1) {
          this.ModelList = res.data
          this.ModelValue = res.uid
        }
        else {
          this.ModelValue = ""
        }
        this.DeviceModelDialog = true
      }
    },
    async ModelCommit() {
      let res = await this.$api.change_model({
        sn: this.ModelSN,
        uid: this.ModelValue,
      })
      console.log(res)
      if (res.status == 1) {
        this.$message({
          message: '修改成功',
          type: 'success',
        })
        this.onRefresh();
      }
      this.DeviceModelDialog = false
    },

    // 设备分配
    async OpenAllocateDialog(index) {
      // console.log(this.pg_list.bind_or_not)
      if (this.pg_list.bind_or_not) {
        this.AllocSN = this.tbdata[index].sn

        let res = await this.$api.device_owner({
          sn: this.AllocSN
        })
        if (res.status == 1) {
          this.AllocList = res.data
          this.AllocValue = res.uid
        }
        else {
          this.AllocValue = ""
        }
        this.DeviceAllocateDialog = true
      }
    },
    async AllocateCommit() {
      let res = await this.$api.bind_or_not({
        sn: this.AllocSN,
        uid: this.AllocValue,
      })
      console.log(res)
      if (res.status == 1) {
        this.$message({
          message: '修改成功',
          type: 'success',
        })
        this.onRefresh();
      }
      this.DeviceAllocateDialog = false
    },

    // async FilterVerifyCommit(index) {
    //   let op = localStorage.getItem('op');
    //   if (op === null || op === '') {
    //     op = this.info.name;
    //     localStorage.setItem('op', op);
    //   }
    //   let res = await this.$api.filter_verify({
    //     ci:this.FilterVerifyData[index].ci+"",
    //     sn: this.FilterVerifyCID,
    //     op:op,
    //
    //   })
    //   console.log(res)
    //   if (res.status == 1) {
    //     this.$message({
    //       message: '核销成功',
    //       type: 'success',
    //     })
    //     this.GetFilter();
    //   }
    // },
    async querySearchAsync(queryString, cb) {
      try {
        const res = await this.$api.search_uid({
          name: queryString + ""
        });
        console.log(res);

        if (res.status === 1) {
          // 将服务器返回的[{name, id}]格式转换为 autocomplete 需要的[{value}]格式
          const suggestions = res.data.map(item => ({
            value: item.name,  // 显示名称
            id: item.id        // 保留ID供后续使用
          }));
          cb(suggestions);
        } else {
          cb([]);
        }
      } catch (error) {
        console.error('搜索请求失败:', error);
        cb([]);
      }
    },

    // 处理选中事件，记录ID
    handleSelect(item) {
      this.searchuid = item.id;  // 将选中项的ID赋值给searchid
      console.log("SEL", this.searchuid)
      this.onRefresh();  // 触发刷新
    },

    // 主刷新
    async onRefresh() {
      if (this.searchdls == "") {
        this.searchuid = ""
      }
      let res = await this.$api.device_list({
        uid: this.searchuid + "",
        name: this.searchinput + "",
        dev: this.deviceinput + "",
        status: this.ssvalue + "",
        sn: this.searchsn + "",
        sn_type: this.SNorCID + "",
        phone: this.searchphone + "",
        le: this.leinput + "",
        p: this.currPage + "",
        z: this.currSize + "",
        sort: !this.ordercheck,
      })
      console.log("refreash", res)
      if (res.status == 1) {
        this.tbdata = res.data
        if (this.currTotal != res.total) {
          console.log("this.currTotal != res.total", this.currTotal, res.total)
          this.currPage = 1
          this.currTotal = res.total // *2024年12月18日
          this.onRefresh()
        }


      }
    },
    async onRefreshOnce() {
      this.currPage = 1

      let res = await this.$api.device_list({
        uid: this.searchuid + "",
        name: this.searchinput + "",
        dev: this.deviceinput + "",
        status: this.ssvalue + "",
        sn: this.searchsn + "",
        sn_type: this.SNorCID + "",
        phone: this.searchphone + "",
        le: this.leinput + "",
        p: this.currPage + "",
        z: this.currSize + "",
        sort: !this.ordercheck,
      })
      console.log("refreash", res)
      if (res.status == 1) {
        this.tbdata = res.data
        this.currTotal = res.total // *2024年12月18日
      }
    },
    //  async GetFilter() {
    //   let res = await this.$api.coupon_list({
    //     s: this.FilterVerifySearch+"",
    //     t: "",
    //     p: "1",
    //     z: "30",
    //     by:"id"
    //   })
    //   // console.log(res)
    //   if (res.status == 1) {
    //     this.FilterVerifyData = res.data
    //   }
    // },
    async RefleshConfig() {
      let res = await this.$api.device_config({
        sn: this.configSN + "",
      })
      console.log(res)
      if (res.status == 1) {
        this.configData = res.data
        this.runData = res.run
      }
    },
    async DeviceConfigCommit(k, v) {
      console.log("commit", k + "", v + "")
      let op = localStorage.getItem('op');
      if (op === null || op === '') {
        op = this.info.name;
        localStorage.setItem('op', op);
      }
      let res = await this.$api.device_config_commit({
        key: k + "",
        val: v + "",
        sn: this.configSN,
        op: op,
      })
      console.log(res)
      if (res.status == 1) {
        this.$message({
          message: res.msg,
          type: 'success',
        })
      }
    },
    // 仅填充LED(F3C1D)默认风速参数到输入框，不下发设置
    SetLEDDefaultConfig() {
      this.$set(this.configData, 'l', 93)   // 风速低
      this.$set(this.configData, 'm', 95)   // 风速中
      this.$set(this.configData, 'h', 97)   // 风速高
      this.$set(this.configData, 's', 100)  // 停机风速
    },
    async RefleshServiceList() {
      let res = await this.$api.service_list({
        sn: this.ServiceSN + "",
      })
      // console.log(res)
      if (res.status == 1) {
        this.ServiceData = res.data


      }
    },
    // async ServiceCommit() {
    //   let res = await this.$api.service_commit({
    //     data:this.ServiceForm,
    //     id:this.ServiceByID,
    //     op:this.ServiceWaiter,
    //   })
    //   console.log(res)
    //   if (res.status == 1) {
    //     this.$message({
    //       message: res.msg,
    //       type: 'success',
    //     })
    //     this.RefleshServiceList();
    //   }
    // },

    // 获取页面上可用的按钮
    async PG_Query() {
      let res = await this.$api.pg_query({
        pg: this.pg_list,
      })

      // console.log("pg ->", res)
      if (res.status == 1) {
        this.pg_list = res.data
      }

      console.log("====>", this.pg_list)

      // let btnNum = 0
      // for (let k in this.pg_list)
      //   if (this.pg_list[k])
      //     btnNum++

      // this.btnwidth = 400
      //
      // if (this.pg_list.history_data){
      //   btnNum = btnNum - 1
      // }
      //
      // if (btnNum >= 4){
      //   this.btnwidth = this.btnwidth + (btnNum-4)*90
      // }

      // charge_device: false,
      //     rename_device: false,
      //     enable_device: false,
      //     bind_or_not: false,
      //     device_order_export: false,
      //     charge_order_export: false,
      //     infinite_times: false,
      //     delete_device: false,
      //     history_data:false,

      if (this.pg_list.bind_or_not) {
        this.btnwidth = 650
      }
      else {
        this.btnwidth = 600
      }


    },
    async DeleteDeviceCommit(index) {
      let res = await this.$api.delete_device({
        sn: this.tbdata[index].sn + ""
      })
      console.log(res)
      if (res.status == 1) {
        this.$message({
          message: '删除成功',
          type: 'success',
        })
        this.onRefresh();
      }
    },
    handleSizeChange(val) {
      this.currSize = val
      this.currPage = 1
      this.onRefresh()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.onRefresh()
    },
    temperatureFormatter(row, column, cellValue) {
      return cellValue + '℃';
    },
    countFormatter(row, column, cellValue) {
      return cellValue + '次';
    },
    formatRemainDay(value) {
      if (value <= -999) return '--';
      return value + '天';
    },
    getDayColor(value) {
      if (value <= -999) return 'black';
      if (value <= 0) return 'red';
      if (value < 5) return 'DarkOrange';
      return 'darkgreen';
    },
    GenSN() {
      const timestamp = Date.now().toString().slice(-10);
      const randomNum = Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000;
      this.addDeviceSN = `X${timestamp}${randomNum}`;
    },
    GenCID() {
      const timestamp = Date.now().toString().slice(-10, -6);
      const randomNum = Math.floor(Math.random() * (999 - 100 + 1)) + 100;
      this.addDeviceCID = `X${timestamp}${randomNum}`;
    },
  }
}
</script>

<style scoped>
.search {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}


.detail-card .el-button {
  margin: 8px;
  margin-bottom: 14px;
  font-size: 16px;
  width: 92%
}

::v-deep .custom-striped-table .el-table__body tr.el-table__row--striped {
  background-color: transparent !important;
}

::v-deep .custom-striped-table .el-table__body tr:nth-child(odd).el-table__row--striped td {
  background-color: rgba(255, 252, 249, 0.4);
}

::v-deep .custom-striped-table .el-table__body tr:nth-child(even).el-table__row--striped td {
  background-color: rgba(252, 252, 251, 0.8);
}
</style>
